import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  JSON: { input: string; output: string; }
  JSONObject: { input: Record<string, any>; output: Record<string, any>; }
};

export type AppCard = {
  __typename?: 'AppCard';
  color?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  event_id: Scalars['Int']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  permissions?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AppCardInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['Int']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AppCardUpdate = {
  color?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['Int']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AppSchedule = {
  __typename?: 'AppSchedule';
  card_id: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  permissions?: Maybe<Scalars['String']['output']>;
};

export type AppScheduleInput = {
  card_id: Scalars['Int']['input'];
  content: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['String']['input']>;
};

export type AppScheduleUpdate = {
  card_id: Scalars['Int']['input'];
  content: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  permissions?: InputMaybe<Scalars['String']['input']>;
};

export type Camp = {
  __typename?: 'Camp';
  active: Scalars['Boolean']['output'];
  app_passwords?: Maybe<Scalars['String']['output']>;
  campCode?: Maybe<Scalars['String']['output']>;
  campCollections?: Maybe<Scalars['JSONObject']['output']>;
  campTimeTable?: Maybe<Scalars['JSON']['output']>;
  camp_id: Scalars['Int']['output'];
  camp_leader_email?: Maybe<Scalars['String']['output']>;
  churchTshirts?: Maybe<Scalars['JSON']['output']>;
  contactInfoObject?: Maybe<Scalars['JSON']['output']>;
  created: Scalars['Date']['output'];
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  end_date: Scalars['DateTime']['output'];
  extraDescription?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Media>;
  interests_active: Scalars['Boolean']['output'];
  last_signup_date: Scalars['DateTime']['output'];
  leader_day: Scalars['Boolean']['output'];
  leader_day_info?: Maybe<Scalars['String']['output']>;
  leader_edit?: Maybe<Scalars['Boolean']['output']>;
  leader_meet: Scalars['Boolean']['output'];
  leader_meet_info?: Maybe<Scalars['String']['output']>;
  livings_active: Scalars['Boolean']['output'];
  modified: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  panicMode?: Maybe<Scalars['Boolean']['output']>;
  panicModeText?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<Scalars['String']['output']>;
  payment_codes?: Maybe<Scalars['String']['output']>;
  require_last_4: Scalars['Boolean']['output'];
  sharedLinks?: Maybe<Array<SharedLink>>;
  shared_link_password?: Maybe<Scalars['String']['output']>;
  signup: Scalars['Boolean']['output'];
  start_date: Scalars['DateTime']['output'];
  studygroups_active?: Maybe<Scalars['Boolean']['output']>;
  tshirts_active: Scalars['Boolean']['output'];
};

export type CampChurch = {
  __typename?: 'CampChurch';
  admin_link?: Maybe<Scalars['String']['output']>;
  admin_link_enabled: Scalars['Boolean']['output'];
  camp_id: Scalars['Int']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  group_collection_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  leader_link?: Maybe<Scalars['String']['output']>;
  leader_link_enabled: Scalars['Boolean']['output'];
  mainConductorId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  startStudyGroup?: Maybe<StudyGroup>;
  studygroupCollection?: Maybe<StudyGroupCollection>;
  tshirtVariant?: Maybe<Scalars['String']['output']>;
};

export type CampChurchInput = {
  admin_link_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  camp_id: Scalars['Int']['input'];
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  leader_link_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  mainConductorId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tshirtVariant?: InputMaybe<Scalars['String']['input']>;
};

export type CampCollection = {
  __typename?: 'CampCollection';
  camp_id?: Maybe<Scalars['Int']['output']>;
  collection?: Maybe<CampCollections>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  sortId?: Maybe<Scalars['Int']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
};

export type CampCollectionInput = {
  camp_id?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  sortId?: InputMaybe<Scalars['Int']['input']>;
};

export enum CampCollections {
  Churches = 'churches',
  Interests = 'interests',
  Livings = 'livings',
  Roles = 'roles',
  Tshirts = 'tshirts'
}

export type CampColumn = {
  __typename?: 'CampColumn';
  adminListOrder?: Maybe<Scalars['Int']['output']>;
  camp_id: Scalars['Int']['output'];
  cardListOrder?: Maybe<Scalars['Int']['output']>;
  collection?: Maybe<CampCollections>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  filterType?: Maybe<Scalars['Int']['output']>;
  fixed?: Maybe<Scalars['Boolean']['output']>;
  gdprDeleteAfter?: Maybe<Scalars['Int']['output']>;
  gdprDeleted: Scalars['Boolean']['output'];
  header?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  hiddenOnSignup?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  inputType?: Maybe<InputType>;
  link?: Maybe<Scalars['String']['output']>;
  maximum?: Maybe<Scalars['Int']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonDeletable?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  readPermission: Scalars['Int']['output'];
  relationalId?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  secureField?: Maybe<Scalars['Boolean']['output']>;
  showIf?: Maybe<Scalars['String']['output']>;
  subfield?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Scalars['String']['output']>;
  writePermission: Scalars['Int']['output'];
};

export type CampContact = {
  __typename?: 'CampContact';
  card_id?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CampContactInput = {
  card_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CampContactUpdate = {
  card_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CampPermission = {
  __typename?: 'CampPermission';
  code: Scalars['String']['output'];
  event_id: Scalars['Int']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CampPermissionInput = {
  code: Scalars['String']['input'];
  event_id: Scalars['Int']['input'];
  icon: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CampPermissionUpdate = {
  code?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['Int']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CampRole = {
  __typename?: 'CampRole';
  camp_id: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  extraMailInformation?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isLeader?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  receivesAppCode: Scalars['Boolean']['output'];
  receivesExtraMailInformation: Scalars['Boolean']['output'];
  role_slug: Scalars['String']['output'];
  used?: Maybe<Scalars['Int']['output']>;
};

export type CampRoleUpdate = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  extraMailInformation?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  receivesAppCode?: InputMaybe<Scalars['Boolean']['input']>;
  receivesExtraMailInformation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampTimeTable = {
  __typename?: 'CampTimeTable';
  date: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
};

export type CampUpdate = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  app_passwords?: InputMaybe<Scalars['String']['input']>;
  campCode?: InputMaybe<Scalars['String']['input']>;
  campTimeTable?: InputMaybe<Scalars['JSON']['input']>;
  camp_id?: InputMaybe<Scalars['Int']['input']>;
  camp_leader_email?: InputMaybe<Scalars['String']['input']>;
  churchTshirts?: InputMaybe<Scalars['JSON']['input']>;
  contactInfoObject?: InputMaybe<Scalars['JSON']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  extraDescription?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  interests_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_signup_date?: InputMaybe<Scalars['DateTime']['input']>;
  leader_day?: InputMaybe<Scalars['Boolean']['input']>;
  leader_day_info?: InputMaybe<Scalars['String']['input']>;
  leader_meet?: InputMaybe<Scalars['Boolean']['input']>;
  leader_meet_info?: InputMaybe<Scalars['String']['input']>;
  livings_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  panicMode?: InputMaybe<Scalars['Boolean']['input']>;
  panicModeText?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<Scalars['String']['input']>;
  payment_codes?: InputMaybe<Scalars['String']['input']>;
  require_last_4?: InputMaybe<Scalars['Boolean']['input']>;
  shared_link_password?: InputMaybe<Scalars['String']['input']>;
  signup?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  studygroups_active?: InputMaybe<Scalars['Boolean']['input']>;
  tshirts_active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatInput = {
  message: Scalars['String']['input'];
  news_id: Scalars['Int']['input'];
  token: Scalars['String']['input'];
  user_name: Scalars['String']['input'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  news_id: Scalars['Int']['output'];
  user_name: Scalars['String']['output'];
};

export type ChurchLink = {
  __typename?: 'ChurchLink';
  admin_link?: Maybe<Scalars['String']['output']>;
  admin_link_enabled?: Maybe<Scalars['Boolean']['output']>;
  camp?: Maybe<Camp>;
  campColumns?: Maybe<Array<CampColumn>>;
  camp_id: Scalars['Int']['output'];
  group_collection_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  infoboxes?: Maybe<Array<ChurchLinkInfoBox>>;
  leader_link?: Maybe<Scalars['String']['output']>;
  leader_link_enabled?: Maybe<Scalars['Boolean']['output']>;
  mainConductorId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  persons?: Maybe<Array<Person>>;
  startStudyGroup?: Maybe<StudyGroup>;
  studygroupCollection?: Maybe<StudyGroupCollection>;
};

export type ChurchLinkInfoBox = {
  __typename?: 'ChurchLinkInfoBox';
  camp_id: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isHeadLeader: Scalars['Boolean']['output'];
  isLeader: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  sortId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ChurchLinkInfoBoxInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isHeadLeader?: InputMaybe<Scalars['Boolean']['input']>;
  isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  sortId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePersonResult = {
  __typename?: 'CreatePersonResult';
  appCode?: Maybe<Scalars['String']['output']>;
  person: Person;
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};

export type Heart = {
  __typename?: 'Heart';
  collection: HeartCollection;
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

/** Collection refers to which table/collection is 'liked' */
export enum HeartCollection {
  Newspost = 'NEWSPOST',
  Pushnotification = 'PUSHNOTIFICATION'
}

export enum InputType {
  Boolean = 'boolean',
  Collection = 'collection',
  Edit = 'edit',
  Email = 'email',
  Id = 'id',
  Number = 'number',
  Payments = 'payments',
  Phone = 'phone',
  Text = 'text',
  Textarea = 'textarea',
  Values = 'values'
}

export type Media = {
  __typename?: 'Media';
  createdAt: Scalars['DateTime']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  mimetype?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orientation?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  addCampChurch?: Maybe<CampChurch>;
  addCampChurches?: Maybe<Array<Maybe<CampChurch>>>;
  addCampCollectionItems?: Maybe<Array<Maybe<CampCollection>>>;
  addChat?: Maybe<Scalars['Boolean']['output']>;
  addChurchLinkInfoBox?: Maybe<ChurchLinkInfoBox>;
  addGroupCollection?: Maybe<CampChurch>;
  checkPayment?: Maybe<Payment>;
  createAppCard?: Maybe<AppCard>;
  createAppSchedule?: Maybe<AppSchedule>;
  createCamp?: Maybe<Camp>;
  createCampColumn?: Maybe<CampColumn>;
  createCampContact?: Maybe<CampContact>;
  createCampPermission?: Maybe<CampPermission>;
  createMissingCampRoles?: Maybe<Array<Maybe<CampRole>>>;
  createNewsPost?: Maybe<NewsPost>;
  createOneTimeCode: Scalars['String']['output'];
  createPayment: Payment;
  createPerson: CreatePersonResult;
  createPushNotification?: Maybe<PushNotification>;
  createSharedLink?: Maybe<SharedLink>;
  createStudygroup: StudyGroup;
  createTimeTableEntry?: Maybe<CampTimeTable>;
  createUser?: Maybe<User>;
  deleteAppCard?: Maybe<Scalars['Boolean']['output']>;
  deleteAppSchedule?: Maybe<Scalars['Boolean']['output']>;
  deleteCamp?: Maybe<Scalars['Boolean']['output']>;
  deleteCampChurch?: Maybe<Scalars['Int']['output']>;
  deleteCampCollectionItem?: Maybe<Scalars['Int']['output']>;
  deleteCampColumn: Scalars['Int']['output'];
  deleteCampContact?: Maybe<Scalars['Boolean']['output']>;
  deleteCampPermission?: Maybe<Scalars['Boolean']['output']>;
  deleteChurchLinkInfoBox?: Maybe<Scalars['Int']['output']>;
  deleteMedia?: Maybe<Scalars['Boolean']['output']>;
  deleteNewsPost?: Maybe<Scalars['Boolean']['output']>;
  deletePushNotification?: Maybe<Scalars['Boolean']['output']>;
  deleteSharedLink?: Maybe<Scalars['Int']['output']>;
  deleteStudygroup: Scalars['Int']['output'];
  deleteTimeTableEntry?: Maybe<Scalars['Boolean']['output']>;
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  generateReport?: Maybe<Scalars['String']['output']>;
  heartNewsPost?: Maybe<Scalars['Boolean']['output']>;
  heartPushNotification?: Maybe<Scalars['Boolean']['output']>;
  login?: Maybe<User>;
  logout?: Maybe<Scalars['Boolean']['output']>;
  mergeChurchWithGroupCollection?: Maybe<CampChurch>;
  refundPayment?: Maybe<Payment>;
  regenerateHeadLeaderLink?: Maybe<CampChurch>;
  regenerateLeaderLink?: Maybe<CampChurch>;
  regenerateSharedLink?: Maybe<SharedLink>;
  registerPushTokenForCamp?: Maybe<Scalars['Boolean']['output']>;
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  sendEmail?: Maybe<Payment>;
  sendHeadleaderEmail?: Maybe<Scalars['Boolean']['output']>;
  separateChurchFromGroupCollection?: Maybe<CampChurch>;
  togglePushTokenEnabled?: Maybe<Scalars['Boolean']['output']>;
  updateAppCard?: Maybe<AppCard>;
  updateAppSchedule?: Maybe<AppSchedule>;
  updateCamp?: Maybe<Camp>;
  updateCampChurch?: Maybe<CampChurch>;
  updateCampCollection?: Maybe<CampCollection>;
  updateCampColumn?: Maybe<CampColumn>;
  updateCampContact?: Maybe<CampContact>;
  updateCampPermission?: Maybe<CampPermission>;
  updateCampRole?: Maybe<CampRole>;
  updateChurchLinkInfoBox?: Maybe<ChurchLinkInfoBox>;
  updateGdprDays?: Maybe<Array<Maybe<CampColumn>>>;
  updateNewsPost?: Maybe<NewsPost>;
  updatePayment?: Maybe<Payment>;
  updatePerson?: Maybe<Person>;
  updatePersonStudygroup?: Maybe<Person>;
  updatePushNotification?: Maybe<PushNotification>;
  updateSharedLink?: Maybe<SharedLink>;
  updateStudygroup?: Maybe<StudyGroup>;
  updateTimeTableEntry?: Maybe<CampTimeTable>;
  updateUser?: Maybe<User>;
  updateUserAuthorizedAreas?: Maybe<User>;
};


export type MutationAddCampChurchArgs = {
  input: CampChurchInput;
};


export type MutationAddCampChurchesArgs = {
  input: Array<InputMaybe<CampChurchInput>>;
};


export type MutationAddCampCollectionItemsArgs = {
  collection: CampCollections;
  input: Array<InputMaybe<CampCollectionInput>>;
};


export type MutationAddChatArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  news_id: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddChurchLinkInfoBoxArgs = {
  body: ChurchLinkInfoBoxInput;
  camp_id: Scalars['Int']['input'];
};


export type MutationAddGroupCollectionArgs = {
  churchId: Scalars['Int']['input'];
};


export type MutationCheckPaymentArgs = {
  paymentId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateAppCardArgs = {
  body: AppCardInput;
};


export type MutationCreateAppScheduleArgs = {
  body: AppScheduleInput;
};


export type MutationCreateCampArgs = {
  body?: InputMaybe<CampUpdate>;
};


export type MutationCreateCampColumnArgs = {
  camp_id: Scalars['Int']['input'];
  details?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type MutationCreateCampContactArgs = {
  body: CampContactInput;
};


export type MutationCreateCampPermissionArgs = {
  body: CampPermissionInput;
};


export type MutationCreateMissingCampRolesArgs = {
  camp_id: Scalars['Int']['input'];
};


export type MutationCreateNewsPostArgs = {
  body: NewsPostInput;
};


export type MutationCreatePaymentArgs = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  camp_id: Scalars['Int']['input'];
  lines?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  person_id: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreatePersonArgs = {
  camp_id: Scalars['Int']['input'];
  oneTimeCode?: InputMaybe<Scalars['String']['input']>;
  values: Scalars['JSONObject']['input'];
};


export type MutationCreatePushNotificationArgs = {
  body: PushNotificationInput;
};


export type MutationCreateSharedLinkArgs = {
  body: SharedLinkInput;
  camp_id: Scalars['Int']['input'];
};


export type MutationCreateStudygroupArgs = {
  groupCollectionId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTimeTableEntryArgs = {
  body: TimeTableInput;
};


export type MutationCreateUserArgs = {
  body?: InputMaybe<UserInput>;
};


export type MutationDeleteAppCardArgs = {
  event_id: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationDeleteAppScheduleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCampArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCampChurchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCampCollectionItemArgs = {
  collection: CampCollections;
  id: Scalars['Int']['input'];
};


export type MutationDeleteCampColumnArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCampContactArgs = {
  campContactId: Scalars['String']['input'];
  card_id: Scalars['Int']['input'];
};


export type MutationDeleteCampPermissionArgs = {
  campPermissionId: Scalars['Int']['input'];
  camp_id: Scalars['Int']['input'];
};


export type MutationDeleteChurchLinkInfoBoxArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteMediaArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteNewsPostArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePushNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteSharedLinkArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteStudygroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTimeTableEntryArgs = {
  card_id: Scalars['Int']['input'];
  timeTableId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationGenerateReportArgs = {
  campIds: Array<InputMaybe<Scalars['Int']['input']>>;
  password: Scalars['String']['input'];
};


export type MutationHeartNewsPostArgs = {
  id: Scalars['Int']['input'];
  remove?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationHeartPushNotificationArgs = {
  id: Scalars['Int']['input'];
  remove?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  usernameOrEmail: Scalars['String']['input'];
};


export type MutationMergeChurchWithGroupCollectionArgs = {
  groupCollectionId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationRefundPaymentArgs = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegenerateHeadLeaderLinkArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRegenerateLeaderLinkArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRegenerateSharedLinkArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRegisterPushTokenForCampArgs = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  camp_id: Scalars['Int']['input'];
  device_token?: InputMaybe<Scalars['String']['input']>;
  expo_token?: InputMaybe<Scalars['String']['input']>;
  installation_id?: InputMaybe<Scalars['String']['input']>;
  leaderPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationSendEmailArgs = {
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendHeadleaderEmailArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSeparateChurchFromGroupCollectionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationTogglePushTokenEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  expo_token: Scalars['String']['input'];
  installation_id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAppCardArgs = {
  body: AppCardUpdate;
};


export type MutationUpdateAppScheduleArgs = {
  body: AppScheduleUpdate;
};


export type MutationUpdateCampArgs = {
  body?: InputMaybe<CampUpdate>;
};


export type MutationUpdateCampChurchArgs = {
  input: CampChurchInput;
};


export type MutationUpdateCampCollectionArgs = {
  collection: CampCollections;
  input: CampCollectionInput;
};


export type MutationUpdateCampColumnArgs = {
  details?: InputMaybe<Scalars['JSONObject']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCampContactArgs = {
  body?: InputMaybe<CampContactUpdate>;
};


export type MutationUpdateCampPermissionArgs = {
  body: CampPermissionUpdate;
};


export type MutationUpdateCampRoleArgs = {
  id: Scalars['Int']['input'];
  input: CampRoleUpdate;
};


export type MutationUpdateChurchLinkInfoBoxArgs = {
  body: ChurchLinkInfoBoxInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateGdprDaysArgs = {
  camp_id: Scalars['Int']['input'];
  columnsObject?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type MutationUpdateNewsPostArgs = {
  body: NewsPostUpdate;
};


export type MutationUpdatePaymentArgs = {
  body: PaymentUpdate;
  paymentId: Scalars['Int']['input'];
};


export type MutationUpdatePersonArgs = {
  id: Scalars['Int']['input'];
  values: Scalars['JSONObject']['input'];
};


export type MutationUpdatePersonStudygroupArgs = {
  id: Scalars['Int']['input'];
  studygroupId: Scalars['Int']['input'];
};


export type MutationUpdatePushNotificationArgs = {
  body: PushNotificationUpdate;
};


export type MutationUpdateSharedLinkArgs = {
  body: SharedLinkInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateStudygroupArgs = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTimeTableEntryArgs = {
  body?: InputMaybe<TimeTableUpdate>;
};


export type MutationUpdateUserArgs = {
  body: UserUpdate;
  userId: Scalars['Int']['input'];
};


export type MutationUpdateUserAuthorizedAreasArgs = {
  areas: Scalars['String']['input'];
  campId: Scalars['Int']['input'];
  isCampEditor: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export enum MutationType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export type NewsPost = {
  __typename?: 'NewsPost';
  camp?: Maybe<Camp>;
  camp_id?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hearts: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  image?: Maybe<Media>;
  link?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  passwords?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['String']['output']>;
  restrictedAudience: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type NewsPostInput = {
  camp_id?: InputMaybe<Scalars['Int']['input']>;
  card_id?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hearts?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  passwords?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['String']['input']>;
  restrictedAudience?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type NewsPostUpdate = {
  card_id?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  imageId?: InputMaybe<Scalars['Int']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  passwords?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['String']['input']>;
  restrictedAudience?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Int']['output']>;
  camp_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lines?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  person_id: Scalars['Int']['output'];
  person_name?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  swish_error?: Maybe<Scalars['String']['output']>;
  swish_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type PaymentInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  camp_id: Scalars['Int']['input'];
  lines?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  person_id: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentUpdate = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  camp_id: Scalars['Int']['input'];
  person_id: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['Int']['input']>;
};

export type Person = {
  __typename?: 'Person';
  camp_id: Scalars['Int']['output'];
  church?: Maybe<CampChurch>;
  church_id?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted: Scalars['Boolean']['output'];
  details?: Maybe<Scalars['JSONObject']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  group_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  interest1?: Maybe<CampCollection>;
  interest1_id?: Maybe<Scalars['Int']['output']>;
  interest2?: Maybe<CampCollection>;
  interest2_id?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  living?: Maybe<CampCollection>;
  living_id?: Maybe<Scalars['Int']['output']>;
  payments_sum?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<CampRole>;
  role_id?: Maybe<Scalars['Int']['output']>;
  studygroup_id?: Maybe<Scalars['Int']['output']>;
  tshirt?: Maybe<CampCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PersonMutationPayload = {
  __typename?: 'PersonMutationPayload';
  mutation: MutationType;
  node: Person;
};

export type PersonStats = {
  __typename?: 'PersonStats';
  today: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  week: Scalars['Int']['output'];
};

export type PushNotification = {
  __typename?: 'PushNotification';
  camp?: Maybe<Camp>;
  camp_id?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hearts: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  newspost?: Maybe<NewsPost>;
  newspost_id?: Maybe<Scalars['Int']['output']>;
  passwords?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['String']['output']>;
  restrictedAudience: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PushNotificationInput = {
  camp_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hearts?: InputMaybe<Scalars['Int']['input']>;
  newspost_id?: InputMaybe<Scalars['Int']['input']>;
  passwords?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['String']['input']>;
  restrictedAudience?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type PushNotificationUpdate = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  passwords?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['String']['input']>;
  restrictedAudience?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PushToken = {
  __typename?: 'PushToken';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  expo_token?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  installation_id?: Maybe<Scalars['String']['output']>;
  push_receipt_status?: Maybe<Scalars['String']['output']>;
  push_ticket_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  adminChurchLink?: Maybe<ChurchLink>;
  appCards?: Maybe<Array<Maybe<AppCard>>>;
  appSchedules?: Maybe<Array<Maybe<AppSchedule>>>;
  camp?: Maybe<Camp>;
  campChurches?: Maybe<Array<Maybe<CampChurch>>>;
  campCollection?: Maybe<Array<Maybe<CampCollection>>>;
  campCollections?: Maybe<Scalars['JSONObject']['output']>;
  campColumns?: Maybe<Array<CampColumn>>;
  campContacts?: Maybe<Array<Maybe<CampContact>>>;
  campFromCampCode?: Maybe<Camp>;
  campMainConductors?: Maybe<Array<Maybe<Person>>>;
  campPermissions?: Maybe<Array<Maybe<CampPermission>>>;
  campRoles?: Maybe<Array<Maybe<CampRole>>>;
  campTimeTable?: Maybe<Array<Maybe<CampTimeTable>>>;
  camps?: Maybe<Array<Maybe<Camp>>>;
  campsFromYear?: Maybe<Array<Maybe<Camp>>>;
  chats?: Maybe<Array<Maybe<ChatMessage>>>;
  churchLinkInfoBoxes?: Maybe<Array<Maybe<ChurchLinkInfoBox>>>;
  leaderChurchLink?: Maybe<ChurchLink>;
  me?: Maybe<User>;
  mediaLibrary?: Maybe<Array<Maybe<Media>>>;
  newsPosts?: Maybe<Array<Maybe<NewsPost>>>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  persons?: Maybe<Array<Maybe<Person>>>;
  personsStatistics: PersonStats;
  pushNotifications?: Maybe<Array<Maybe<PushNotification>>>;
  sharedLink?: Maybe<SharedLink>;
  sharedLinks?: Maybe<Array<Maybe<SharedLink>>>;
  studygroupCollection?: Maybe<StudyGroupCollection>;
  studygroupStatistics?: Maybe<StudygroupStatistics>;
  supportedVersion: Scalars['String']['output'];
  users?: Maybe<Array<Maybe<User>>>;
};


export type QueryAdminChurchLinkArgs = {
  link: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAppCardsArgs = {
  event_id: Scalars['Int']['input'];
};


export type QueryAppSchedulesArgs = {
  card_id: Scalars['Int']['input'];
};


export type QueryCampArgs = {
  camp_id: Scalars['Int']['input'];
};


export type QueryCampChurchesArgs = {
  camp_id: Scalars['Int']['input'];
};


export type QueryCampCollectionArgs = {
  camp_id: Scalars['Int']['input'];
  collection: CampCollections;
};


export type QueryCampCollectionsArgs = {
  camp_id: Scalars['Int']['input'];
};


export type QueryCampColumnsArgs = {
  camp_id: Scalars['Int']['input'];
};


export type QueryCampContactsArgs = {
  card_id: Scalars['Int']['input'];
};


export type QueryCampFromCampCodeArgs = {
  campCode: Scalars['Int']['input'];
};


export type QueryCampMainConductorsArgs = {
  camp_id: Scalars['Int']['input'];
};


export type QueryCampPermissionsArgs = {
  camp_id: Scalars['Int']['input'];
};


export type QueryCampRolesArgs = {
  camp_id: Scalars['Int']['input'];
};


export type QueryCampTimeTableArgs = {
  card_id: Scalars['Int']['input'];
};


export type QueryCampsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCampsFromYearArgs = {
  year: Scalars['Int']['input'];
};


export type QueryChatsArgs = {
  news_id: Scalars['Int']['input'];
};


export type QueryChurchLinkInfoBoxesArgs = {
  camp_id: Scalars['Int']['input'];
};


export type QueryLeaderChurchLinkArgs = {
  link: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNewsPostsArgs = {
  card_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentsArgs = {
  camp_id: Scalars['Int']['input'];
};


export type QueryPersonsArgs = {
  camp_id: Scalars['Int']['input'];
};


export type QueryPersonsStatisticsArgs = {
  camp_id: Scalars['Int']['input'];
};


export type QueryPushNotificationsArgs = {
  camp_id?: InputMaybe<Scalars['Int']['input']>;
  leader?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySharedLinkArgs = {
  link: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySharedLinksArgs = {
  camp_id: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStudygroupCollectionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStudygroupStatisticsArgs = {
  camp_id: Scalars['Int']['input'];
};


export type QuerySupportedVersionArgs = {
  myVersion: Scalars['String']['input'];
};

export type SharedLink = {
  __typename?: 'SharedLink';
  active?: Maybe<Scalars['Boolean']['output']>;
  allowedColumns?: Maybe<Array<Scalars['String']['output']>>;
  camp?: Maybe<Camp>;
  campColumns?: Maybe<Array<CampColumn>>;
  camp_id?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  filters?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  link: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  persons?: Maybe<Array<Person>>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type SharedLinkInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowedColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type StudyGroup = {
  __typename?: 'StudyGroup';
  church_id?: Maybe<Scalars['Int']['output']>;
  group_collection_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  persons?: Maybe<Array<Maybe<Person>>>;
};

export type StudyGroupCollection = {
  __typename?: 'StudyGroupCollection';
  camp_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  studygroups?: Maybe<Array<Maybe<StudyGroup>>>;
};

export type StudygroupStatistics = {
  __typename?: 'StudygroupStatistics';
  studygroupCount?: Maybe<Scalars['Int']['output']>;
  studygroupsFromPersonsInStartgroups?: Maybe<Array<Maybe<StudyGroup>>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  _empty?: Maybe<Scalars['String']['output']>;
  hearts?: Maybe<Heart>;
  personMutated: PersonMutationPayload;
  sub_chats?: Maybe<Array<Maybe<ChatMessage>>>;
};


export type SubscriptionPersonMutatedArgs = {
  camp_id: Scalars['Int']['input'];
};


export type SubscriptionSub_ChatsArgs = {
  news_id: Scalars['Int']['input'];
};

export type TimeTableInput = {
  card_id: Scalars['Int']['input'];
  date: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
};

export type TimeTableUpdate = {
  card_id: Scalars['Int']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  siteAdmin: Scalars['Boolean']['output'];
  superAdmin: Scalars['Boolean']['output'];
  userAuthorizedAreas?: Maybe<Array<Maybe<UserAuthorization>>>;
  username: Scalars['String']['output'];
};

export type UserAuthorization = {
  __typename?: 'UserAuthorization';
  authorizedAreas: Array<Scalars['String']['output']>;
  camp_id: Scalars['Int']['output'];
  isCampEditor: Scalars['Boolean']['output'];
  user_id: Scalars['Int']['output'];
};

export type UserInput = {
  email: Scalars['String']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  siteAdmin: Scalars['Boolean']['input'];
  username: Scalars['String']['input'];
};

export type UserUpdate = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  siteAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppCampFragment = { __typename?: 'Camp', camp_id: number, name: string, description?: string | undefined, extraDescription?: string | undefined, camp_leader_email?: string | undefined, tshirts_active: boolean, livings_active: boolean, interests_active: boolean, require_last_4: boolean, shared_link_password?: string | undefined, app_passwords?: string | undefined, campCode?: string | undefined, start_date: string, end_date: string, last_signup_date: string, panicMode?: boolean | undefined, panicModeText?: string | undefined, payment?: string | undefined, payment_codes?: string | undefined, leader_day: boolean, leader_day_info?: string | undefined, leader_meet: boolean, leader_meet_info?: string | undefined, studygroups_active?: boolean | undefined, signup: boolean, active: boolean, deleted: boolean, created: string, modified: string, image?: { __typename?: 'Media', id: number, name?: string | undefined, url?: string | undefined, thumbnail?: string | undefined, mimetype?: string | undefined, width?: number | undefined, height?: number | undefined, orientation?: number | undefined, createdAt: string, updatedAt: string } | undefined };


export type AppCampFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppMediaFragment = { __typename?: 'Media', id: number, name?: string | undefined, url?: string | undefined, thumbnail?: string | undefined, mimetype?: string | undefined, width?: number | undefined, height?: number | undefined, orientation?: number | undefined, createdAt: string, updatedAt: string };


export type AppMediaFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppInfoBoxFragment = { __typename?: 'ChurchLinkInfoBox', id: number, camp_id: number, sortId?: number | undefined, title?: string | undefined, description?: string | undefined, linkText?: string | undefined, link?: string | undefined, isLeader: boolean, isHeadLeader: boolean };


export type AppInfoBoxFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppCampRoleFragment = { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined };


export type AppCampRoleFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppCampCollectionFragment = { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined };


export type AppCampCollectionFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppCampColumnFragment = { __typename?: 'CampColumn', id: number, camp_id: number, name?: string | undefined, header?: string | undefined, title?: string | undefined, placeholder?: string | undefined, inputType?: InputType | undefined, page?: number | undefined, required?: boolean | undefined, collection?: CampCollections | undefined, values?: string | undefined, relationalId?: string | undefined, order?: number | undefined, adminListOrder?: number | undefined, cardListOrder?: number | undefined, description?: string | undefined, link?: string | undefined, price?: string | undefined, subfield?: number | undefined, showIf?: string | undefined, hiddenOnSignup?: boolean | undefined, fixed?: boolean | undefined, filterType?: number | undefined, hidden?: boolean | undefined, disabled?: boolean | undefined, nonDeletable?: boolean | undefined, secureField?: boolean | undefined, readPermission: number, writePermission: number, gdprDeleteAfter?: number | undefined, gdprDeleted: boolean };


export type AppCampColumnFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppTimeTableFragment = { __typename?: 'CampTimeTable', id: string, date: string, end_date?: string | undefined, place?: string | undefined, name: string, description?: string | undefined, permissions?: string | undefined };


export type AppTimeTableFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppCampContactFragment = { __typename?: 'CampContact', id: string, name?: string | undefined, phone?: string | undefined, email?: string | undefined, description?: string | undefined, permissions?: string | undefined, card_id?: number | undefined };


export type AppCampContactFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppCampPermissionFragment = { __typename?: 'CampPermission', id: number, name: string, code: string, icon: string };


export type AppCampPermissionFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppAppCardFragment = { __typename?: 'AppCard', id: number, name: string, type: string, icon: string, color?: string | undefined, order?: number | undefined, permissions?: string | undefined };


export type AppAppCardFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppAppScheduleFragment = { __typename?: 'AppSchedule', id: number, card_id: number, content: string, permissions?: string | undefined };


export type AppAppScheduleFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppCampChurchFragment = { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined };


export type AppCampChurchFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppStudyGroupCollectionFragment = { __typename?: 'StudyGroupCollection', id: number, name?: string | undefined, camp_id: number, studygroups?: Array<{ __typename?: 'StudyGroup', id: number, name?: string | undefined, group_collection_id: number, church_id?: number | undefined, persons?: Array<{ __typename?: 'Person', studygroup_id?: number | undefined, id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined } | undefined> | undefined } | undefined> | undefined };


export type AppStudyGroupCollectionFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppStudyGroupFragment = { __typename?: 'StudyGroup', id: number, name?: string | undefined, group_collection_id: number, church_id?: number | undefined, persons?: Array<{ __typename?: 'Person', studygroup_id?: number | undefined, id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined } | undefined> | undefined };


export type AppStudyGroupFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppPersonFragment = { __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined };


export type AppPersonFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppChurchLinkFragment = { __typename?: 'ChurchLink', id: number, name?: string | undefined, group_collection_id?: number | undefined, camp_id: number, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled?: boolean | undefined, leader_link?: string | undefined, leader_link_enabled?: boolean | undefined, campColumns?: Array<{ __typename?: 'CampColumn', id: number, camp_id: number, name?: string | undefined, header?: string | undefined, title?: string | undefined, placeholder?: string | undefined, inputType?: InputType | undefined, page?: number | undefined, required?: boolean | undefined, collection?: CampCollections | undefined, values?: string | undefined, relationalId?: string | undefined, order?: number | undefined, adminListOrder?: number | undefined, cardListOrder?: number | undefined, description?: string | undefined, link?: string | undefined, price?: string | undefined, subfield?: number | undefined, showIf?: string | undefined, hiddenOnSignup?: boolean | undefined, fixed?: boolean | undefined, filterType?: number | undefined, hidden?: boolean | undefined, disabled?: boolean | undefined, nonDeletable?: boolean | undefined, secureField?: boolean | undefined, readPermission: number, writePermission: number, gdprDeleteAfter?: number | undefined, gdprDeleted: boolean }> | undefined, studygroupCollection?: { __typename?: 'StudyGroupCollection', id: number, name?: string | undefined, camp_id: number, studygroups?: Array<{ __typename?: 'StudyGroup', id: number, name?: string | undefined, group_collection_id: number, church_id?: number | undefined, persons?: Array<{ __typename?: 'Person', studygroup_id?: number | undefined, id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined } | undefined> | undefined } | undefined> | undefined } | undefined, startStudyGroup?: { __typename?: 'StudyGroup', persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined } | undefined> | undefined } | undefined, infoboxes?: Array<{ __typename?: 'ChurchLinkInfoBox', id: number, camp_id: number, sortId?: number | undefined, title?: string | undefined, description?: string | undefined, linkText?: string | undefined, link?: string | undefined, isLeader: boolean, isHeadLeader: boolean }> | undefined };


export type AppChurchLinkFragmentVariables = Exact<{ [key: string]: never; }>;

export type PersonCampCollectionsFragment = { __typename?: 'Person', church?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined, living?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest1?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest2?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, tshirt?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined };


export type PersonCampCollectionsFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppPaymentFragment = { __typename?: 'Payment', id: number, camp_id: number, person_id: number, person_name?: string | undefined, amount?: number | undefined, status?: number | undefined, modified?: string | undefined, swish_error?: string | undefined, lines?: string | undefined, uuid?: string | undefined, type?: string | undefined, number?: string | undefined, reason?: string | undefined };


export type AppPaymentFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppNewsPostFragment = { __typename?: 'NewsPost', id: number, title: string, description?: string | undefined, hearts: number, createdAt: string, restrictedAudience: boolean, link?: string | undefined, linkText?: string | undefined, passwords?: string | undefined, permissions?: string | undefined, image?: { __typename?: 'Media', id: number, name?: string | undefined, url?: string | undefined, thumbnail?: string | undefined, mimetype?: string | undefined, width?: number | undefined, height?: number | undefined, orientation?: number | undefined, createdAt: string, updatedAt: string } | undefined };


export type AppNewsPostFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppPushNotificationFragment = { __typename?: 'PushNotification', id: number, title: string, description?: string | undefined, hearts: number, restrictedAudience: boolean, passwords?: string | undefined, createdAt: string, updatedAt: string, newspost_id?: number | undefined, permissions?: string | undefined };


export type AppPushNotificationFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppSharedLinkFragment = { __typename?: 'SharedLink', id: number, link: string, camp_id?: number | undefined, name?: string | undefined, startDate?: string | undefined, endDate?: string | undefined, lastUsed?: string | undefined, active?: boolean | undefined };


export type AppSharedLinkFragmentVariables = Exact<{ [key: string]: never; }>;

export type SharedLinkPersonsFragment = { __typename?: 'SharedLink', camp?: { __typename?: 'Camp', camp_id: number, name: string, start_date: string, end_date: string, campCollections?: Record<string, any> | undefined } | undefined, persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, church?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined, living?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest1?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest2?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, tshirt?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined }> | undefined, campColumns?: Array<{ __typename?: 'CampColumn', id: number, camp_id: number, name?: string | undefined, header?: string | undefined, title?: string | undefined, placeholder?: string | undefined, inputType?: InputType | undefined, page?: number | undefined, required?: boolean | undefined, collection?: CampCollections | undefined, values?: string | undefined, relationalId?: string | undefined, order?: number | undefined, adminListOrder?: number | undefined, cardListOrder?: number | undefined, description?: string | undefined, link?: string | undefined, price?: string | undefined, subfield?: number | undefined, showIf?: string | undefined, hiddenOnSignup?: boolean | undefined, fixed?: boolean | undefined, filterType?: number | undefined, hidden?: boolean | undefined, disabled?: boolean | undefined, nonDeletable?: boolean | undefined, secureField?: boolean | undefined, readPermission: number, writePermission: number, gdprDeleteAfter?: number | undefined, gdprDeleted: boolean }> | undefined };


export type SharedLinkPersonsFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppUserFragment = { __typename?: 'User', id: number, email: string, username: string, first_name?: string | undefined, last_name?: string | undefined, phone?: string | undefined, active: boolean, siteAdmin: boolean, superAdmin: boolean };


export type AppUserFragmentVariables = Exact<{ [key: string]: never; }>;

export type AppUserAuthAreasFragment = { __typename?: 'User', userAuthorizedAreas?: Array<{ __typename?: 'UserAuthorization', authorizedAreas: Array<string>, camp_id: number, user_id: number, isCampEditor: boolean } | undefined> | undefined };


export type AppUserAuthAreasFragmentVariables = Exact<{ [key: string]: never; }>;

export type CampsQueryVariables = Exact<{ [key: string]: never; }>;


export type CampsQuery = { __typename?: 'Query', camps?: Array<{ __typename?: 'Camp', camp_id: number, name: string, description?: string | undefined, extraDescription?: string | undefined, camp_leader_email?: string | undefined, tshirts_active: boolean, livings_active: boolean, interests_active: boolean, require_last_4: boolean, shared_link_password?: string | undefined, app_passwords?: string | undefined, campCode?: string | undefined, start_date: string, end_date: string, last_signup_date: string, panicMode?: boolean | undefined, panicModeText?: string | undefined, payment?: string | undefined, payment_codes?: string | undefined, leader_day: boolean, leader_day_info?: string | undefined, leader_meet: boolean, leader_meet_info?: string | undefined, studygroups_active?: boolean | undefined, signup: boolean, active: boolean, deleted: boolean, created: string, modified: string, image?: { __typename?: 'Media', id: number, name?: string | undefined, url?: string | undefined, thumbnail?: string | undefined, mimetype?: string | undefined, width?: number | undefined, height?: number | undefined, orientation?: number | undefined, createdAt: string, updatedAt: string } | undefined } | undefined> | undefined };

export type CampsFromYearQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type CampsFromYearQuery = { __typename?: 'Query', campsFromYear?: Array<{ __typename?: 'Camp', camp_id: number, name: string, description?: string | undefined, extraDescription?: string | undefined, camp_leader_email?: string | undefined, tshirts_active: boolean, livings_active: boolean, interests_active: boolean, require_last_4: boolean, shared_link_password?: string | undefined, app_passwords?: string | undefined, campCode?: string | undefined, start_date: string, end_date: string, last_signup_date: string, panicMode?: boolean | undefined, panicModeText?: string | undefined, payment?: string | undefined, payment_codes?: string | undefined, leader_day: boolean, leader_day_info?: string | undefined, leader_meet: boolean, leader_meet_info?: string | undefined, studygroups_active?: boolean | undefined, signup: boolean, active: boolean, deleted: boolean, created: string, modified: string, image?: { __typename?: 'Media', id: number, name?: string | undefined, url?: string | undefined, thumbnail?: string | undefined, mimetype?: string | undefined, width?: number | undefined, height?: number | undefined, orientation?: number | undefined, createdAt: string, updatedAt: string } | undefined } | undefined> | undefined };

export type CampQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type CampQuery = { __typename?: 'Query', camp?: { __typename?: 'Camp', camp_id: number, name: string, description?: string | undefined, extraDescription?: string | undefined, camp_leader_email?: string | undefined, tshirts_active: boolean, livings_active: boolean, interests_active: boolean, require_last_4: boolean, shared_link_password?: string | undefined, app_passwords?: string | undefined, campCode?: string | undefined, start_date: string, end_date: string, last_signup_date: string, panicMode?: boolean | undefined, panicModeText?: string | undefined, payment?: string | undefined, payment_codes?: string | undefined, leader_day: boolean, leader_day_info?: string | undefined, leader_meet: boolean, leader_meet_info?: string | undefined, studygroups_active?: boolean | undefined, signup: boolean, active: boolean, deleted: boolean, created: string, modified: string, image?: { __typename?: 'Media', id: number, name?: string | undefined, url?: string | undefined, thumbnail?: string | undefined, mimetype?: string | undefined, width?: number | undefined, height?: number | undefined, orientation?: number | undefined, createdAt: string, updatedAt: string } | undefined } | undefined };

export type CreateCampMutationVariables = Exact<{
  body: CampUpdate;
}>;


export type CreateCampMutation = { __typename?: 'Mutation', createCamp?: { __typename?: 'Camp', camp_id: number, name: string, description?: string | undefined, extraDescription?: string | undefined, camp_leader_email?: string | undefined, tshirts_active: boolean, livings_active: boolean, interests_active: boolean, require_last_4: boolean, shared_link_password?: string | undefined, app_passwords?: string | undefined, campCode?: string | undefined, start_date: string, end_date: string, last_signup_date: string, panicMode?: boolean | undefined, panicModeText?: string | undefined, payment?: string | undefined, payment_codes?: string | undefined, leader_day: boolean, leader_day_info?: string | undefined, leader_meet: boolean, leader_meet_info?: string | undefined, studygroups_active?: boolean | undefined, signup: boolean, active: boolean, deleted: boolean, created: string, modified: string, image?: { __typename?: 'Media', id: number, name?: string | undefined, url?: string | undefined, thumbnail?: string | undefined, mimetype?: string | undefined, width?: number | undefined, height?: number | undefined, orientation?: number | undefined, createdAt: string, updatedAt: string } | undefined } | undefined };

export type UpdateCampMutationVariables = Exact<{
  body: CampUpdate;
}>;


export type UpdateCampMutation = { __typename?: 'Mutation', updateCamp?: { __typename?: 'Camp', camp_id: number, name: string, description?: string | undefined, extraDescription?: string | undefined, camp_leader_email?: string | undefined, tshirts_active: boolean, livings_active: boolean, interests_active: boolean, require_last_4: boolean, shared_link_password?: string | undefined, app_passwords?: string | undefined, campCode?: string | undefined, start_date: string, end_date: string, last_signup_date: string, panicMode?: boolean | undefined, panicModeText?: string | undefined, payment?: string | undefined, payment_codes?: string | undefined, leader_day: boolean, leader_day_info?: string | undefined, leader_meet: boolean, leader_meet_info?: string | undefined, studygroups_active?: boolean | undefined, signup: boolean, active: boolean, deleted: boolean, created: string, modified: string, image?: { __typename?: 'Media', id: number, name?: string | undefined, url?: string | undefined, thumbnail?: string | undefined, mimetype?: string | undefined, width?: number | undefined, height?: number | undefined, orientation?: number | undefined, createdAt: string, updatedAt: string } | undefined } | undefined };

export type ChurchLinkInfoBoxesQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type ChurchLinkInfoBoxesQuery = { __typename?: 'Query', churchLinkInfoBoxes?: Array<{ __typename?: 'ChurchLinkInfoBox', id: number, camp_id: number, sortId?: number | undefined, title?: string | undefined, description?: string | undefined, linkText?: string | undefined, link?: string | undefined, isLeader: boolean, isHeadLeader: boolean } | undefined> | undefined };

export type AddChurchLinkInfoBoxMutationVariables = Exact<{
  camp_id: Scalars['Int']['input'];
  body: ChurchLinkInfoBoxInput;
}>;


export type AddChurchLinkInfoBoxMutation = { __typename?: 'Mutation', addChurchLinkInfoBox?: { __typename?: 'ChurchLinkInfoBox', id: number, camp_id: number, sortId?: number | undefined, title?: string | undefined, description?: string | undefined, linkText?: string | undefined, link?: string | undefined, isLeader: boolean, isHeadLeader: boolean } | undefined };

export type UpdateChurchLinkInfoBoxMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  body: ChurchLinkInfoBoxInput;
}>;


export type UpdateChurchLinkInfoBoxMutation = { __typename?: 'Mutation', updateChurchLinkInfoBox?: { __typename?: 'ChurchLinkInfoBox', id: number, camp_id: number, sortId?: number | undefined, title?: string | undefined, description?: string | undefined, linkText?: string | undefined, link?: string | undefined, isLeader: boolean, isHeadLeader: boolean } | undefined };

export type DeleteChurchLinkInfoBoxMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteChurchLinkInfoBoxMutation = { __typename?: 'Mutation', deleteChurchLinkInfoBox?: number | undefined };

export type CampRolesQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type CampRolesQuery = { __typename?: 'Query', campRoles?: Array<{ __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined> | undefined };

export type UpdateCampRoleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: CampRoleUpdate;
}>;


export type UpdateCampRoleMutation = { __typename?: 'Mutation', updateCampRole?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined };

export type CreateMissingCampRolesMutationVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type CreateMissingCampRolesMutation = { __typename?: 'Mutation', createMissingCampRoles?: Array<{ __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined> | undefined };

export type CampCollectionQueryVariables = Exact<{
  collection: CampCollections;
  camp_id: Scalars['Int']['input'];
}>;


export type CampCollectionQuery = { __typename?: 'Query', campCollection?: Array<{ __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined> | undefined };

export type UpdateCampCollectionMutationVariables = Exact<{
  collection: CampCollections;
  input: CampCollectionInput;
}>;


export type UpdateCampCollectionMutation = { __typename?: 'Mutation', updateCampCollection?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined };

export type AddCampCollectionItemsMutationVariables = Exact<{
  collection: CampCollections;
  input: Array<InputMaybe<CampCollectionInput>> | InputMaybe<CampCollectionInput>;
}>;


export type AddCampCollectionItemsMutation = { __typename?: 'Mutation', addCampCollectionItems?: Array<{ __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined> | undefined };

export type DeleteCampCollectionItemMutationVariables = Exact<{
  collection: CampCollections;
  id: Scalars['Int']['input'];
}>;


export type DeleteCampCollectionItemMutation = { __typename?: 'Mutation', deleteCampCollectionItem?: number | undefined };

export type CampCollectionsQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type CampCollectionsQuery = { __typename?: 'Query', campCollections?: Record<string, any> | undefined };

export type CampColumnsQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type CampColumnsQuery = { __typename?: 'Query', campColumns?: Array<{ __typename?: 'CampColumn', id: number, camp_id: number, name?: string | undefined, header?: string | undefined, title?: string | undefined, placeholder?: string | undefined, inputType?: InputType | undefined, page?: number | undefined, required?: boolean | undefined, collection?: CampCollections | undefined, values?: string | undefined, relationalId?: string | undefined, order?: number | undefined, adminListOrder?: number | undefined, cardListOrder?: number | undefined, description?: string | undefined, link?: string | undefined, price?: string | undefined, subfield?: number | undefined, showIf?: string | undefined, hiddenOnSignup?: boolean | undefined, fixed?: boolean | undefined, filterType?: number | undefined, hidden?: boolean | undefined, disabled?: boolean | undefined, nonDeletable?: boolean | undefined, secureField?: boolean | undefined, readPermission: number, writePermission: number, gdprDeleteAfter?: number | undefined, gdprDeleted: boolean }> | undefined };

export type CreateCampColumnMutationVariables = Exact<{
  camp_id: Scalars['Int']['input'];
  details?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type CreateCampColumnMutation = { __typename?: 'Mutation', createCampColumn?: { __typename?: 'CampColumn', id: number, camp_id: number, name?: string | undefined, header?: string | undefined, title?: string | undefined, placeholder?: string | undefined, inputType?: InputType | undefined, page?: number | undefined, required?: boolean | undefined, collection?: CampCollections | undefined, values?: string | undefined, relationalId?: string | undefined, order?: number | undefined, adminListOrder?: number | undefined, cardListOrder?: number | undefined, description?: string | undefined, link?: string | undefined, price?: string | undefined, subfield?: number | undefined, showIf?: string | undefined, hiddenOnSignup?: boolean | undefined, fixed?: boolean | undefined, filterType?: number | undefined, hidden?: boolean | undefined, disabled?: boolean | undefined, nonDeletable?: boolean | undefined, secureField?: boolean | undefined, readPermission: number, writePermission: number, gdprDeleteAfter?: number | undefined, gdprDeleted: boolean } | undefined };

export type UpdateCampColumnMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  details?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type UpdateCampColumnMutation = { __typename?: 'Mutation', updateCampColumn?: { __typename?: 'CampColumn', id: number, camp_id: number, name?: string | undefined, header?: string | undefined, title?: string | undefined, placeholder?: string | undefined, inputType?: InputType | undefined, page?: number | undefined, required?: boolean | undefined, collection?: CampCollections | undefined, values?: string | undefined, relationalId?: string | undefined, order?: number | undefined, adminListOrder?: number | undefined, cardListOrder?: number | undefined, description?: string | undefined, link?: string | undefined, price?: string | undefined, subfield?: number | undefined, showIf?: string | undefined, hiddenOnSignup?: boolean | undefined, fixed?: boolean | undefined, filterType?: number | undefined, hidden?: boolean | undefined, disabled?: boolean | undefined, nonDeletable?: boolean | undefined, secureField?: boolean | undefined, readPermission: number, writePermission: number, gdprDeleteAfter?: number | undefined, gdprDeleted: boolean } | undefined };

export type UpdateGdprDaysMutationVariables = Exact<{
  camp_id: Scalars['Int']['input'];
  columnsObject?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type UpdateGdprDaysMutation = { __typename?: 'Mutation', updateGdprDays?: Array<{ __typename?: 'CampColumn', id: number, camp_id: number, name?: string | undefined, header?: string | undefined, title?: string | undefined, placeholder?: string | undefined, inputType?: InputType | undefined, page?: number | undefined, required?: boolean | undefined, collection?: CampCollections | undefined, values?: string | undefined, relationalId?: string | undefined, order?: number | undefined, adminListOrder?: number | undefined, cardListOrder?: number | undefined, description?: string | undefined, link?: string | undefined, price?: string | undefined, subfield?: number | undefined, showIf?: string | undefined, hiddenOnSignup?: boolean | undefined, fixed?: boolean | undefined, filterType?: number | undefined, hidden?: boolean | undefined, disabled?: boolean | undefined, nonDeletable?: boolean | undefined, secureField?: boolean | undefined, readPermission: number, writePermission: number, gdprDeleteAfter?: number | undefined, gdprDeleted: boolean } | undefined> | undefined };

export type DeleteCampColumnMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCampColumnMutation = { __typename?: 'Mutation', deleteCampColumn: number };

export type CampTimeTableQueryVariables = Exact<{
  card_id: Scalars['Int']['input'];
}>;


export type CampTimeTableQuery = { __typename?: 'Query', campTimeTable?: Array<{ __typename?: 'CampTimeTable', id: string, date: string, end_date?: string | undefined, place?: string | undefined, name: string, description?: string | undefined, permissions?: string | undefined } | undefined> | undefined };

export type CreateTimeTableEntryMutationVariables = Exact<{
  timeTableEntry: TimeTableInput;
}>;


export type CreateTimeTableEntryMutation = { __typename?: 'Mutation', createTimeTableEntry?: { __typename?: 'CampTimeTable', id: string, date: string, end_date?: string | undefined, place?: string | undefined, name: string, description?: string | undefined, permissions?: string | undefined } | undefined };

export type UpdateTimeTableEntryMutationVariables = Exact<{
  body?: InputMaybe<TimeTableUpdate>;
}>;


export type UpdateTimeTableEntryMutation = { __typename?: 'Mutation', updateTimeTableEntry?: { __typename?: 'CampTimeTable', id: string, date: string, end_date?: string | undefined, place?: string | undefined, name: string, description?: string | undefined, permissions?: string | undefined } | undefined };

export type DeleteTimeTableEntryMutationVariables = Exact<{
  card_id: Scalars['Int']['input'];
  timeTableId: Scalars['String']['input'];
}>;


export type DeleteTimeTableEntryMutation = { __typename?: 'Mutation', deleteTimeTableEntry?: boolean | undefined };

export type CampContactsQueryVariables = Exact<{
  card_id: Scalars['Int']['input'];
}>;


export type CampContactsQuery = { __typename?: 'Query', campContacts?: Array<{ __typename?: 'CampContact', id: string, name?: string | undefined, phone?: string | undefined, email?: string | undefined, description?: string | undefined, permissions?: string | undefined, card_id?: number | undefined } | undefined> | undefined };

export type CreateCampContactMutationVariables = Exact<{
  campContact: CampContactInput;
}>;


export type CreateCampContactMutation = { __typename?: 'Mutation', createCampContact?: { __typename?: 'CampContact', id: string, name?: string | undefined, phone?: string | undefined, email?: string | undefined, description?: string | undefined, permissions?: string | undefined, card_id?: number | undefined } | undefined };

export type UpdateCampContactMutationVariables = Exact<{
  campContact?: InputMaybe<CampContactUpdate>;
}>;


export type UpdateCampContactMutation = { __typename?: 'Mutation', updateCampContact?: { __typename?: 'CampContact', id: string, name?: string | undefined, phone?: string | undefined, email?: string | undefined, description?: string | undefined, permissions?: string | undefined, card_id?: number | undefined } | undefined };

export type DeleteCampContactMutationVariables = Exact<{
  card_id: Scalars['Int']['input'];
  campContactId: Scalars['String']['input'];
}>;


export type DeleteCampContactMutation = { __typename?: 'Mutation', deleteCampContact?: boolean | undefined };

export type CampPermissionQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type CampPermissionQuery = { __typename?: 'Query', campPermissions?: Array<{ __typename?: 'CampPermission', id: number, name: string, code: string, icon: string } | undefined> | undefined };

export type CreateCampPermissionMutationVariables = Exact<{
  campPermission: CampPermissionInput;
}>;


export type CreateCampPermissionMutation = { __typename?: 'Mutation', createCampPermission?: { __typename?: 'CampPermission', id: number, name: string, code: string, icon: string } | undefined };

export type UpdateCampPermissionMutationVariables = Exact<{
  campPermission: CampPermissionUpdate;
}>;


export type UpdateCampPermissionMutation = { __typename?: 'Mutation', updateCampPermission?: { __typename?: 'CampPermission', id: number, name: string, code: string, icon: string } | undefined };

export type DeleteCampPermissionMutationVariables = Exact<{
  camp_id: Scalars['Int']['input'];
  campPermissionId: Scalars['Int']['input'];
}>;


export type DeleteCampPermissionMutation = { __typename?: 'Mutation', deleteCampPermission?: boolean | undefined };

export type AppCardsQueryVariables = Exact<{
  event_id: Scalars['Int']['input'];
}>;


export type AppCardsQuery = { __typename?: 'Query', appCards?: Array<{ __typename?: 'AppCard', id: number, name: string, type: string, icon: string, color?: string | undefined, order?: number | undefined, permissions?: string | undefined } | undefined> | undefined };

export type CreateAppCardMutationVariables = Exact<{
  appCard: AppCardInput;
}>;


export type CreateAppCardMutation = { __typename?: 'Mutation', createAppCard?: { __typename?: 'AppCard', id: number, name: string, type: string, icon: string, color?: string | undefined, order?: number | undefined, permissions?: string | undefined } | undefined };

export type UpdateAppCardMutationVariables = Exact<{
  appCard: AppCardUpdate;
}>;


export type UpdateAppCardMutation = { __typename?: 'Mutation', updateAppCard?: { __typename?: 'AppCard', id: number, name: string, type: string, icon: string, color?: string | undefined, order?: number | undefined, permissions?: string | undefined } | undefined };

export type DeleteAppCardMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  event_id: Scalars['Int']['input'];
}>;


export type DeleteAppCardMutation = { __typename?: 'Mutation', deleteAppCard?: boolean | undefined };

export type AppSchedulesQueryVariables = Exact<{
  card_id: Scalars['Int']['input'];
}>;


export type AppSchedulesQuery = { __typename?: 'Query', appSchedules?: Array<{ __typename?: 'AppSchedule', id: number, card_id: number, content: string, permissions?: string | undefined } | undefined> | undefined };

export type CreateAppScheduleMutationVariables = Exact<{
  appSchedule: AppScheduleInput;
}>;


export type CreateAppScheduleMutation = { __typename?: 'Mutation', createAppSchedule?: { __typename?: 'AppSchedule', id: number, card_id: number, content: string, permissions?: string | undefined } | undefined };

export type UpdateAppScheduleMutationVariables = Exact<{
  appSchedule: AppScheduleUpdate;
}>;


export type UpdateAppScheduleMutation = { __typename?: 'Mutation', updateAppSchedule?: { __typename?: 'AppSchedule', id: number, card_id: number, content: string, permissions?: string | undefined } | undefined };

export type DeleteAppScheduleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteAppScheduleMutation = { __typename?: 'Mutation', deleteAppSchedule?: boolean | undefined };

export type CampChurchesQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type CampChurchesQuery = { __typename?: 'Query', campChurches?: Array<{ __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined> | undefined };

export type CampChurchesWithStudygroupQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type CampChurchesWithStudygroupQuery = { __typename?: 'Query', campChurches?: Array<{ __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined, studygroupCollection?: { __typename?: 'StudyGroupCollection', id: number, name?: string | undefined, camp_id: number, studygroups?: Array<{ __typename?: 'StudyGroup', id: number, name?: string | undefined, group_collection_id: number, church_id?: number | undefined, persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined } | undefined> | undefined } | undefined> | undefined } | undefined, startStudyGroup?: { __typename?: 'StudyGroup', id: number } | undefined } | undefined> | undefined };

export type UpdateCampChurchMutationVariables = Exact<{
  input: CampChurchInput;
}>;


export type UpdateCampChurchMutation = { __typename?: 'Mutation', updateCampChurch?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined };

export type AddCampChurchMutationVariables = Exact<{
  input: CampChurchInput;
}>;


export type AddCampChurchMutation = { __typename?: 'Mutation', addCampChurch?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined };

export type AddCampChurchesMutationVariables = Exact<{
  input: Array<InputMaybe<CampChurchInput>> | InputMaybe<CampChurchInput>;
}>;


export type AddCampChurchesMutation = { __typename?: 'Mutation', addCampChurches?: Array<{ __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined> | undefined };

export type DeleteCampChurchMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCampChurchMutation = { __typename?: 'Mutation', deleteCampChurch?: number | undefined };

export type MergeChurchWithGroupCollectionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  groupCollectionId: Scalars['Int']['input'];
}>;


export type MergeChurchWithGroupCollectionMutation = { __typename?: 'Mutation', mergeChurchWithGroupCollection?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined };

export type SendHeadleaderEmailMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SendHeadleaderEmailMutation = { __typename?: 'Mutation', sendHeadleaderEmail?: boolean | undefined };

export type RegenerateHeadLeaderLinkMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RegenerateHeadLeaderLinkMutation = { __typename?: 'Mutation', regenerateHeadLeaderLink?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined };

export type RegenerateLeaderLinkMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RegenerateLeaderLinkMutation = { __typename?: 'Mutation', regenerateLeaderLink?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined };

export type SeparateChurchFromGroupCollectionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SeparateChurchFromGroupCollectionMutation = { __typename?: 'Mutation', separateChurchFromGroupCollection?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined };

export type AdminChurchLinkQueryVariables = Exact<{
  link: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminChurchLinkQuery = { __typename?: 'Query', adminChurchLink?: { __typename?: 'ChurchLink', id: number, name?: string | undefined, group_collection_id?: number | undefined, camp_id: number, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled?: boolean | undefined, leader_link?: string | undefined, leader_link_enabled?: boolean | undefined, campColumns?: Array<{ __typename?: 'CampColumn', id: number, camp_id: number, name?: string | undefined, header?: string | undefined, title?: string | undefined, placeholder?: string | undefined, inputType?: InputType | undefined, page?: number | undefined, required?: boolean | undefined, collection?: CampCollections | undefined, values?: string | undefined, relationalId?: string | undefined, order?: number | undefined, adminListOrder?: number | undefined, cardListOrder?: number | undefined, description?: string | undefined, link?: string | undefined, price?: string | undefined, subfield?: number | undefined, showIf?: string | undefined, hiddenOnSignup?: boolean | undefined, fixed?: boolean | undefined, filterType?: number | undefined, hidden?: boolean | undefined, disabled?: boolean | undefined, nonDeletable?: boolean | undefined, secureField?: boolean | undefined, readPermission: number, writePermission: number, gdprDeleteAfter?: number | undefined, gdprDeleted: boolean }> | undefined, studygroupCollection?: { __typename?: 'StudyGroupCollection', id: number, name?: string | undefined, camp_id: number, studygroups?: Array<{ __typename?: 'StudyGroup', id: number, name?: string | undefined, group_collection_id: number, church_id?: number | undefined, persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined } | undefined> | undefined } | undefined> | undefined } | undefined, startStudyGroup?: { __typename?: 'StudyGroup', persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined } | undefined> | undefined } | undefined, infoboxes?: Array<{ __typename?: 'ChurchLinkInfoBox', id: number, camp_id: number, sortId?: number | undefined, title?: string | undefined, description?: string | undefined, linkText?: string | undefined, link?: string | undefined, isLeader: boolean, isHeadLeader: boolean }> | undefined, persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, church?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined, living?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest1?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest2?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, tshirt?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined }> | undefined, camp?: { __typename?: 'Camp', camp_id: number, name: string, start_date: string, end_date: string, studygroups_active?: boolean | undefined, campCollections?: Record<string, any> | undefined, panicMode?: boolean | undefined, panicModeText?: string | undefined } | undefined } | undefined };

export type LeaderChurchLinkQueryVariables = Exact<{
  link: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type LeaderChurchLinkQuery = { __typename?: 'Query', leaderChurchLink?: { __typename?: 'ChurchLink', id: number, name?: string | undefined, group_collection_id?: number | undefined, camp_id: number, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled?: boolean | undefined, leader_link?: string | undefined, leader_link_enabled?: boolean | undefined, campColumns?: Array<{ __typename?: 'CampColumn', id: number, camp_id: number, name?: string | undefined, header?: string | undefined, title?: string | undefined, placeholder?: string | undefined, inputType?: InputType | undefined, page?: number | undefined, required?: boolean | undefined, collection?: CampCollections | undefined, values?: string | undefined, relationalId?: string | undefined, order?: number | undefined, adminListOrder?: number | undefined, cardListOrder?: number | undefined, description?: string | undefined, link?: string | undefined, price?: string | undefined, subfield?: number | undefined, showIf?: string | undefined, hiddenOnSignup?: boolean | undefined, fixed?: boolean | undefined, filterType?: number | undefined, hidden?: boolean | undefined, disabled?: boolean | undefined, nonDeletable?: boolean | undefined, secureField?: boolean | undefined, readPermission: number, writePermission: number, gdprDeleteAfter?: number | undefined, gdprDeleted: boolean }> | undefined, studygroupCollection?: { __typename?: 'StudyGroupCollection', id: number, name?: string | undefined, camp_id: number, studygroups?: Array<{ __typename?: 'StudyGroup', id: number, name?: string | undefined, group_collection_id: number, church_id?: number | undefined, persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined } | undefined> | undefined } | undefined> | undefined } | undefined, startStudyGroup?: { __typename?: 'StudyGroup', persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined } | undefined> | undefined } | undefined, infoboxes?: Array<{ __typename?: 'ChurchLinkInfoBox', id: number, camp_id: number, sortId?: number | undefined, title?: string | undefined, description?: string | undefined, linkText?: string | undefined, link?: string | undefined, isLeader: boolean, isHeadLeader: boolean }> | undefined, persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, church?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined, living?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest1?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest2?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, tshirt?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined }> | undefined, camp?: { __typename?: 'Camp', camp_id: number, name: string, start_date: string, end_date: string, studygroups_active?: boolean | undefined, campCollections?: Record<string, any> | undefined, panicMode?: boolean | undefined, panicModeText?: string | undefined } | undefined } | undefined };

export type StudygroupCollectionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type StudygroupCollectionQuery = { __typename?: 'Query', studygroupCollection?: { __typename?: 'StudyGroupCollection', id: number, name?: string | undefined, camp_id: number, studygroups?: Array<{ __typename?: 'StudyGroup', id: number, name?: string | undefined, group_collection_id: number, church_id?: number | undefined, persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };

export type DeleteStudygroupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteStudygroupMutation = { __typename?: 'Mutation', deleteStudygroup: number };

export type CreateStudygroupMutationVariables = Exact<{
  groupCollectionId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateStudygroupMutation = { __typename?: 'Mutation', createStudygroup: { __typename?: 'StudyGroup', id: number, name?: string | undefined, group_collection_id: number, church_id?: number | undefined, persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined } | undefined> | undefined } };

export type UpdateStudygroupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateStudygroupMutation = { __typename?: 'Mutation', updateStudygroup?: { __typename?: 'StudyGroup', id: number, name?: string | undefined, group_collection_id: number, church_id?: number | undefined, persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined } | undefined> | undefined } | undefined };

export type StudygroupStatisticsQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type StudygroupStatisticsQuery = { __typename?: 'Query', studygroupStatistics?: { __typename?: 'StudygroupStatistics', studygroupCount?: number | undefined, studygroupsFromPersonsInStartgroups?: Array<{ __typename?: 'StudyGroup', id: number, name?: string | undefined, group_collection_id: number, church_id?: number | undefined, persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };

export type MediaLibraryQueryVariables = Exact<{ [key: string]: never; }>;


export type MediaLibraryQuery = { __typename?: 'Query', mediaLibrary?: Array<{ __typename?: 'Media', id: number, name?: string | undefined, url?: string | undefined, thumbnail?: string | undefined, mimetype?: string | undefined, width?: number | undefined, height?: number | undefined, orientation?: number | undefined, createdAt: string, updatedAt: string } | undefined> | undefined };

export type DeleteMediaMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteMediaMutation = { __typename?: 'Mutation', deleteMedia?: boolean | undefined };

export type PaymentsQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type PaymentsQuery = { __typename?: 'Query', payments?: Array<{ __typename?: 'Payment', id: number, camp_id: number, person_id: number, person_name?: string | undefined, amount?: number | undefined, status?: number | undefined, modified?: string | undefined, swish_error?: string | undefined, lines?: string | undefined, uuid?: string | undefined, type?: string | undefined, number?: string | undefined, reason?: string | undefined } | undefined> | undefined };

export type CheckPaymentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CheckPaymentMutation = { __typename?: 'Mutation', checkPayment?: { __typename?: 'Payment', id: number, camp_id: number, person_id: number, person_name?: string | undefined, amount?: number | undefined, status?: number | undefined, modified?: string | undefined, swish_error?: string | undefined, lines?: string | undefined, uuid?: string | undefined, type?: string | undefined, number?: string | undefined, reason?: string | undefined } | undefined };

export type RefundPaymentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  amount: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
}>;


export type RefundPaymentMutation = { __typename?: 'Mutation', refundPayment?: { __typename?: 'Payment', id: number, camp_id: number, person_id: number, person_name?: string | undefined, amount?: number | undefined, status?: number | undefined, modified?: string | undefined, swish_error?: string | undefined, lines?: string | undefined, uuid?: string | undefined, type?: string | undefined, number?: string | undefined, reason?: string | undefined } | undefined };

export type PersonsStatisticsQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type PersonsStatisticsQuery = { __typename?: 'Query', personsStatistics: { __typename?: 'PersonStats', total: number, week: number, today: number } };

export type PersonsQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type PersonsQuery = { __typename?: 'Query', campCollections?: Record<string, any> | undefined, campColumns?: Array<{ __typename?: 'CampColumn', id: number, camp_id: number, name?: string | undefined, header?: string | undefined, title?: string | undefined, placeholder?: string | undefined, inputType?: InputType | undefined, page?: number | undefined, required?: boolean | undefined, collection?: CampCollections | undefined, values?: string | undefined, relationalId?: string | undefined, order?: number | undefined, adminListOrder?: number | undefined, cardListOrder?: number | undefined, description?: string | undefined, link?: string | undefined, price?: string | undefined, subfield?: number | undefined, showIf?: string | undefined, hiddenOnSignup?: boolean | undefined, fixed?: boolean | undefined, filterType?: number | undefined, hidden?: boolean | undefined, disabled?: boolean | undefined, nonDeletable?: boolean | undefined, secureField?: boolean | undefined, readPermission: number, writePermission: number, gdprDeleteAfter?: number | undefined, gdprDeleted: boolean }> | undefined, persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, church?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined, living?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest1?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest2?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, tshirt?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined } | undefined> | undefined };

export type UpdatePersonMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  values: Scalars['JSONObject']['input'];
}>;


export type UpdatePersonMutation = { __typename?: 'Mutation', updatePerson?: { __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, church?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined, living?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest1?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest2?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, tshirt?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined } | undefined };

export type UpdatePersonStudygroupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  studygroupId: Scalars['Int']['input'];
}>;


export type UpdatePersonStudygroupMutation = { __typename?: 'Mutation', updatePersonStudygroup?: { __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, church?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined, living?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest1?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest2?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, tshirt?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined } | undefined };

export type PersonMutatedSubscriptionVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type PersonMutatedSubscription = { __typename?: 'Subscription', personMutated: { __typename?: 'PersonMutationPayload', mutation: MutationType, node: { __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, church?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined, living?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest1?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest2?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, tshirt?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined } } };

export type CampMainConductorsQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type CampMainConductorsQuery = { __typename?: 'Query', campMainConductors?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined } | undefined> | undefined };

export type GenerateReportMutationVariables = Exact<{
  campIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  password: Scalars['String']['input'];
}>;


export type GenerateReportMutation = { __typename?: 'Mutation', generateReport?: string | undefined };

export type CreateOneTimeCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateOneTimeCodeMutation = { __typename?: 'Mutation', createOneTimeCode: string };

export type NewsPostsQueryVariables = Exact<{
  card_id: Scalars['Int']['input'];
}>;


export type NewsPostsQuery = { __typename?: 'Query', newsPosts?: Array<{ __typename?: 'NewsPost', id: number, title: string, description?: string | undefined, hearts: number, createdAt: string, restrictedAudience: boolean, link?: string | undefined, linkText?: string | undefined, passwords?: string | undefined, permissions?: string | undefined, image?: { __typename?: 'Media', id: number, name?: string | undefined, url?: string | undefined, thumbnail?: string | undefined, mimetype?: string | undefined, width?: number | undefined, height?: number | undefined, orientation?: number | undefined, createdAt: string, updatedAt: string } | undefined } | undefined> | undefined };

export type CreateNewsPostMutationVariables = Exact<{
  body: NewsPostInput;
}>;


export type CreateNewsPostMutation = { __typename?: 'Mutation', createNewsPost?: { __typename?: 'NewsPost', id: number, title: string, description?: string | undefined, hearts: number, createdAt: string, restrictedAudience: boolean, link?: string | undefined, linkText?: string | undefined, passwords?: string | undefined, permissions?: string | undefined, image?: { __typename?: 'Media', id: number, name?: string | undefined, url?: string | undefined, thumbnail?: string | undefined, mimetype?: string | undefined, width?: number | undefined, height?: number | undefined, orientation?: number | undefined, createdAt: string, updatedAt: string } | undefined } | undefined };

export type UpdateNewsPostMutationVariables = Exact<{
  body: NewsPostUpdate;
}>;


export type UpdateNewsPostMutation = { __typename?: 'Mutation', updateNewsPost?: { __typename?: 'NewsPost', id: number, title: string, description?: string | undefined, hearts: number, createdAt: string, restrictedAudience: boolean, link?: string | undefined, linkText?: string | undefined, passwords?: string | undefined, permissions?: string | undefined, image?: { __typename?: 'Media', id: number, name?: string | undefined, url?: string | undefined, thumbnail?: string | undefined, mimetype?: string | undefined, width?: number | undefined, height?: number | undefined, orientation?: number | undefined, createdAt: string, updatedAt: string } | undefined } | undefined };

export type DeleteNewsPostMutationVariables = Exact<{
  newsPostId: Scalars['Int']['input'];
}>;


export type DeleteNewsPostMutation = { __typename?: 'Mutation', deleteNewsPost?: boolean | undefined };

export type PushNotificationsQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
}>;


export type PushNotificationsQuery = { __typename?: 'Query', pushNotifications?: Array<{ __typename?: 'PushNotification', id: number, title: string, description?: string | undefined, hearts: number, restrictedAudience: boolean, passwords?: string | undefined, createdAt: string, updatedAt: string, newspost_id?: number | undefined, permissions?: string | undefined } | undefined> | undefined };

export type DeletePushNotificationMutationVariables = Exact<{
  pushNotificationId: Scalars['Int']['input'];
}>;


export type DeletePushNotificationMutation = { __typename?: 'Mutation', deletePushNotification?: boolean | undefined };

export type UpdatePushNotificationMutationVariables = Exact<{
  body: PushNotificationUpdate;
}>;


export type UpdatePushNotificationMutation = { __typename?: 'Mutation', updatePushNotification?: { __typename?: 'PushNotification', id: number, title: string, description?: string | undefined, hearts: number, restrictedAudience: boolean, passwords?: string | undefined, createdAt: string, updatedAt: string, newspost_id?: number | undefined, permissions?: string | undefined } | undefined };

export type CreatePushNotificationMutationVariables = Exact<{
  pushNotificationBody: PushNotificationInput;
}>;


export type CreatePushNotificationMutation = { __typename?: 'Mutation', createPushNotification?: { __typename?: 'PushNotification', id: number, title: string, description?: string | undefined, hearts: number, restrictedAudience: boolean, passwords?: string | undefined, createdAt: string, updatedAt: string, newspost_id?: number | undefined, permissions?: string | undefined } | undefined };

export type HeartsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type HeartsSubscription = { __typename?: 'Subscription', hearts?: { __typename?: 'Heart', id: number, collection: HeartCollection, count: number } | undefined };

export type SharedLinksQueryVariables = Exact<{
  camp_id: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type SharedLinksQuery = { __typename?: 'Query', sharedLinks?: Array<{ __typename?: 'SharedLink', id: number, link: string, camp_id?: number | undefined, name?: string | undefined, startDate?: string | undefined, endDate?: string | undefined, lastUsed?: string | undefined, active?: boolean | undefined } | undefined> | undefined };

export type CreateSharedLinkMutationVariables = Exact<{
  camp_id: Scalars['Int']['input'];
  body: SharedLinkInput;
}>;


export type CreateSharedLinkMutation = { __typename?: 'Mutation', createSharedLink?: { __typename?: 'SharedLink', id: number, link: string, camp_id?: number | undefined, name?: string | undefined, startDate?: string | undefined, endDate?: string | undefined, lastUsed?: string | undefined, active?: boolean | undefined } | undefined };

export type UpdateSharedLinkMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  body: SharedLinkInput;
}>;


export type UpdateSharedLinkMutation = { __typename?: 'Mutation', updateSharedLink?: { __typename?: 'SharedLink', id: number, link: string, camp_id?: number | undefined, name?: string | undefined, startDate?: string | undefined, endDate?: string | undefined, lastUsed?: string | undefined, active?: boolean | undefined } | undefined };

export type RegenerateSharedLinkMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RegenerateSharedLinkMutation = { __typename?: 'Mutation', regenerateSharedLink?: { __typename?: 'SharedLink', id: number, link: string, camp_id?: number | undefined, name?: string | undefined, startDate?: string | undefined, endDate?: string | undefined, lastUsed?: string | undefined, active?: boolean | undefined } | undefined };

export type DeleteSharedLinkMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteSharedLinkMutation = { __typename?: 'Mutation', deleteSharedLink?: number | undefined };

export type SharedLinkQueryVariables = Exact<{
  link: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type SharedLinkQuery = { __typename?: 'Query', sharedLink?: { __typename?: 'SharedLink', id: number, link: string, camp_id?: number | undefined, name?: string | undefined, startDate?: string | undefined, endDate?: string | undefined, lastUsed?: string | undefined, active?: boolean | undefined, camp?: { __typename?: 'Camp', camp_id: number, name: string, start_date: string, end_date: string, campCollections?: Record<string, any> | undefined } | undefined, persons?: Array<{ __typename?: 'Person', id: number, camp_id: number, details?: Record<string, any> | undefined, deleted: boolean, studygroup_id?: number | undefined, createdAt?: string | undefined, updatedAt?: string | undefined, payments_sum?: number | undefined, church?: { __typename?: 'CampChurch', id: number, camp_id: number, name: string, tshirtVariant?: string | undefined, deleted?: boolean | undefined, mainConductorId?: number | undefined, admin_link?: string | undefined, admin_link_enabled: boolean, leader_link?: string | undefined, leader_link_enabled: boolean, group_collection_id?: number | undefined } | undefined, role?: { __typename?: 'CampRole', id: number, role_slug: string, camp_id: number, name?: string | undefined, isLeader?: boolean | undefined, enabled: boolean, description?: string | undefined, receivesExtraMailInformation: boolean, extraMailInformation?: string | undefined, receivesAppCode: boolean, price?: number | undefined, limit?: number | undefined, used?: number | undefined } | undefined, living?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest1?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, interest2?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined, tshirt?: { __typename?: 'CampCollection', collection?: CampCollections | undefined, id: number, name: string, camp_id?: number | undefined, description?: string | undefined, price?: number | undefined, limit?: number | undefined, filter?: string | undefined, deleted: boolean, sortId?: number | undefined } | undefined }> | undefined, campColumns?: Array<{ __typename?: 'CampColumn', id: number, camp_id: number, name?: string | undefined, header?: string | undefined, title?: string | undefined, placeholder?: string | undefined, inputType?: InputType | undefined, page?: number | undefined, required?: boolean | undefined, collection?: CampCollections | undefined, values?: string | undefined, relationalId?: string | undefined, order?: number | undefined, adminListOrder?: number | undefined, cardListOrder?: number | undefined, description?: string | undefined, link?: string | undefined, price?: string | undefined, subfield?: number | undefined, showIf?: string | undefined, hiddenOnSignup?: boolean | undefined, fixed?: boolean | undefined, filterType?: number | undefined, hidden?: boolean | undefined, disabled?: boolean | undefined, nonDeletable?: boolean | undefined, secureField?: boolean | undefined, readPermission: number, writePermission: number, gdprDeleteAfter?: number | undefined, gdprDeleted: boolean }> | undefined } | undefined };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: number, email: string, username: string, first_name?: string | undefined, last_name?: string | undefined, phone?: string | undefined, active: boolean, siteAdmin: boolean, superAdmin: boolean, userAuthorizedAreas?: Array<{ __typename?: 'UserAuthorization', authorizedAreas: Array<string>, camp_id: number, user_id: number, isCampEditor: boolean } | undefined> | undefined } | undefined };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: number, email: string, username: string, first_name?: string | undefined, last_name?: string | undefined, phone?: string | undefined, active: boolean, siteAdmin: boolean, superAdmin: boolean, userAuthorizedAreas?: Array<{ __typename?: 'UserAuthorization', authorizedAreas: Array<string>, camp_id: number, user_id: number, isCampEditor: boolean } | undefined> | undefined } | undefined> | undefined };

export type LoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'User', id: number, email: string, username: string, first_name?: string | undefined, last_name?: string | undefined, phone?: string | undefined, active: boolean, siteAdmin: boolean, superAdmin: boolean, userAuthorizedAreas?: Array<{ __typename?: 'UserAuthorization', authorizedAreas: Array<string>, camp_id: number, user_id: number, isCampEditor: boolean } | undefined> | undefined } | undefined };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: boolean | undefined };

export type CreateUserMutationVariables = Exact<{
  body: UserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id: number, email: string, username: string, first_name?: string | undefined, last_name?: string | undefined, phone?: string | undefined, active: boolean, siteAdmin: boolean, superAdmin: boolean, userAuthorizedAreas?: Array<{ __typename?: 'UserAuthorization', authorizedAreas: Array<string>, camp_id: number, user_id: number, isCampEditor: boolean } | undefined> | undefined } | undefined };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  body: UserUpdate;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: number, email: string, username: string, first_name?: string | undefined, last_name?: string | undefined, phone?: string | undefined, active: boolean, siteAdmin: boolean, superAdmin: boolean, userAuthorizedAreas?: Array<{ __typename?: 'UserAuthorization', authorizedAreas: Array<string>, camp_id: number, user_id: number, isCampEditor: boolean } | undefined> | undefined } | undefined };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: boolean | undefined };

export type ResetPasswordMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: boolean | undefined };

export type UpdateUserAuthorizedAreasMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  campId: Scalars['Int']['input'];
  areas: Scalars['String']['input'];
  isCampEditor: Scalars['Boolean']['input'];
}>;


export type UpdateUserAuthorizedAreasMutation = { __typename?: 'Mutation', updateUserAuthorizedAreas?: { __typename?: 'User', id: number, email: string, username: string, first_name?: string | undefined, last_name?: string | undefined, phone?: string | undefined, active: boolean, siteAdmin: boolean, superAdmin: boolean, userAuthorizedAreas?: Array<{ __typename?: 'UserAuthorization', authorizedAreas: Array<string>, camp_id: number, user_id: number, isCampEditor: boolean } | undefined> | undefined } | undefined };

export const AppMediaFragmentDoc = gql`
    fragment AppMedia on Media {
  id
  name
  url
  thumbnail
  mimetype
  width
  height
  orientation
  createdAt
  updatedAt
}
    `;
export const AppCampFragmentDoc = gql`
    fragment AppCamp on Camp {
  camp_id
  name
  image {
    ...AppMedia
  }
  description
  extraDescription
  camp_leader_email
  tshirts_active
  livings_active
  interests_active
  require_last_4
  shared_link_password
  app_passwords
  campCode
  start_date
  end_date
  last_signup_date
  panicMode
  panicModeText
  payment
  payment_codes
  leader_day
  leader_day_info
  leader_meet
  leader_meet_info
  studygroups_active
  signup
  active
  deleted
  created
  modified
}
    ${AppMediaFragmentDoc}`;
export const AppTimeTableFragmentDoc = gql`
    fragment AppTimeTable on CampTimeTable {
  id
  date
  end_date
  place
  name
  description
  permissions
}
    `;
export const AppCampContactFragmentDoc = gql`
    fragment AppCampContact on CampContact {
  id
  name
  phone
  email
  description
  permissions
  card_id
}
    `;
export const AppCampPermissionFragmentDoc = gql`
    fragment AppCampPermission on CampPermission {
  id
  name
  code
  icon
}
    `;
export const AppAppCardFragmentDoc = gql`
    fragment AppAppCard on AppCard {
  id
  name
  type
  icon
  color
  order
  permissions
}
    `;
export const AppAppScheduleFragmentDoc = gql`
    fragment AppAppSchedule on AppSchedule {
  id
  card_id
  content
  permissions
}
    `;
export const AppCampColumnFragmentDoc = gql`
    fragment AppCampColumn on CampColumn {
  id
  camp_id
  name
  header
  title
  placeholder
  inputType
  page
  required
  collection
  values
  relationalId
  order
  adminListOrder
  cardListOrder
  description
  link
  price
  subfield
  showIf
  hiddenOnSignup
  fixed
  filterType
  hidden
  disabled
  nonDeletable
  secureField
  readPermission
  writePermission
  gdprDeleteAfter
  gdprDeleted
}
    `;
export const AppPersonFragmentDoc = gql`
    fragment AppPerson on Person {
  id
  camp_id
  details
  deleted
  studygroup_id
  createdAt
  updatedAt
  payments_sum
}
    `;
export const AppCampRoleFragmentDoc = gql`
    fragment AppCampRole on CampRole {
  id
  role_slug
  camp_id
  name
  isLeader
  enabled
  description
  receivesExtraMailInformation
  extraMailInformation
  receivesAppCode
  price
  limit
  used
}
    `;
export const AppStudyGroupFragmentDoc = gql`
    fragment AppStudyGroup on StudyGroup {
  id
  name
  group_collection_id
  church_id
  persons {
    ...AppPerson
    studygroup_id
    role {
      ...AppCampRole
    }
  }
}
    ${AppPersonFragmentDoc}
${AppCampRoleFragmentDoc}`;
export const AppStudyGroupCollectionFragmentDoc = gql`
    fragment AppStudyGroupCollection on StudyGroupCollection {
  id
  name
  camp_id
  studygroups {
    ...AppStudyGroup
  }
}
    ${AppStudyGroupFragmentDoc}`;
export const AppInfoBoxFragmentDoc = gql`
    fragment AppInfoBox on ChurchLinkInfoBox {
  id
  camp_id
  sortId
  title
  description
  linkText
  link
  isLeader
  isHeadLeader
}
    `;
export const AppChurchLinkFragmentDoc = gql`
    fragment AppChurchLink on ChurchLink {
  id
  name
  group_collection_id
  campColumns {
    ...AppCampColumn
  }
  camp_id
  studygroupCollection {
    ...AppStudyGroupCollection
  }
  startStudyGroup {
    persons {
      ...AppPerson
    }
  }
  infoboxes {
    ...AppInfoBox
  }
  mainConductorId
  admin_link
  admin_link_enabled
  leader_link
  leader_link_enabled
}
    ${AppCampColumnFragmentDoc}
${AppStudyGroupCollectionFragmentDoc}
${AppPersonFragmentDoc}
${AppInfoBoxFragmentDoc}`;
export const AppPaymentFragmentDoc = gql`
    fragment AppPayment on Payment {
  id
  camp_id
  person_id
  person_name
  amount
  status
  modified
  swish_error
  lines
  uuid
  type
  number
  reason
}
    `;
export const AppNewsPostFragmentDoc = gql`
    fragment AppNewsPost on NewsPost {
  id
  image {
    ...AppMedia
  }
  title
  description
  hearts
  createdAt
  restrictedAudience
  link
  linkText
  passwords
  permissions
}
    ${AppMediaFragmentDoc}`;
export const AppPushNotificationFragmentDoc = gql`
    fragment AppPushNotification on PushNotification {
  id
  title
  description
  hearts
  restrictedAudience
  passwords
  createdAt
  updatedAt
  newspost_id
  permissions
}
    `;
export const AppSharedLinkFragmentDoc = gql`
    fragment AppSharedLink on SharedLink {
  id
  link
  camp_id
  name
  startDate
  endDate
  lastUsed
  active
}
    `;
export const AppCampChurchFragmentDoc = gql`
    fragment AppCampChurch on CampChurch {
  id
  camp_id
  name
  tshirtVariant
  deleted
  mainConductorId
  admin_link
  admin_link_enabled
  leader_link
  leader_link_enabled
  group_collection_id
}
    `;
export const AppCampCollectionFragmentDoc = gql`
    fragment AppCampCollection on CampCollection {
  collection
  id
  name
  camp_id
  description
  price
  limit
  filter
  deleted
  sortId
}
    `;
export const PersonCampCollectionsFragmentDoc = gql`
    fragment PersonCampCollections on Person {
  church {
    ...AppCampChurch
  }
  role {
    ...AppCampRole
  }
  living {
    ...AppCampCollection
  }
  interest1 {
    ...AppCampCollection
  }
  interest2 {
    ...AppCampCollection
  }
  tshirt {
    ...AppCampCollection
  }
}
    ${AppCampChurchFragmentDoc}
${AppCampRoleFragmentDoc}
${AppCampCollectionFragmentDoc}`;
export const SharedLinkPersonsFragmentDoc = gql`
    fragment SharedLinkPersons on SharedLink {
  camp {
    camp_id
    name
    start_date
    end_date
    campCollections
  }
  persons {
    ...AppPerson
    ...PersonCampCollections
  }
  campColumns {
    ...AppCampColumn
  }
}
    ${AppPersonFragmentDoc}
${PersonCampCollectionsFragmentDoc}
${AppCampColumnFragmentDoc}`;
export const AppUserAuthAreasFragmentDoc = gql`
    fragment AppUserAuthAreas on User {
  userAuthorizedAreas {
    authorizedAreas
    camp_id
    user_id
    isCampEditor
  }
}
    `;
export const AppUserFragmentDoc = gql`
    fragment AppUser on User {
  id
  email
  username
  first_name
  last_name
  phone
  active
  siteAdmin
  superAdmin
}
    `;
export const CampsDocument = gql`
    query Camps {
  camps {
    ...AppCamp
  }
}
    ${AppCampFragmentDoc}`;

/**
 * __useCampsQuery__
 *
 * To run a query within a React component, call `useCampsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCampsQuery(baseOptions?: Apollo.QueryHookOptions<CampsQuery, CampsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampsQuery, CampsQueryVariables>(CampsDocument, options);
      }
export function useCampsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampsQuery, CampsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampsQuery, CampsQueryVariables>(CampsDocument, options);
        }
export function useCampsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampsQuery, CampsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampsQuery, CampsQueryVariables>(CampsDocument, options);
        }
export type CampsQueryHookResult = ReturnType<typeof useCampsQuery>;
export type CampsLazyQueryHookResult = ReturnType<typeof useCampsLazyQuery>;
export type CampsSuspenseQueryHookResult = ReturnType<typeof useCampsSuspenseQuery>;
export type CampsQueryResult = Apollo.QueryResult<CampsQuery, CampsQueryVariables>;
export const CampsFromYearDocument = gql`
    query campsFromYear($year: Int!) {
  campsFromYear(year: $year) {
    ...AppCamp
  }
}
    ${AppCampFragmentDoc}`;

/**
 * __useCampsFromYearQuery__
 *
 * To run a query within a React component, call `useCampsFromYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampsFromYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampsFromYearQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useCampsFromYearQuery(baseOptions: Apollo.QueryHookOptions<CampsFromYearQuery, CampsFromYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampsFromYearQuery, CampsFromYearQueryVariables>(CampsFromYearDocument, options);
      }
export function useCampsFromYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampsFromYearQuery, CampsFromYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampsFromYearQuery, CampsFromYearQueryVariables>(CampsFromYearDocument, options);
        }
export function useCampsFromYearSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampsFromYearQuery, CampsFromYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampsFromYearQuery, CampsFromYearQueryVariables>(CampsFromYearDocument, options);
        }
export type CampsFromYearQueryHookResult = ReturnType<typeof useCampsFromYearQuery>;
export type CampsFromYearLazyQueryHookResult = ReturnType<typeof useCampsFromYearLazyQuery>;
export type CampsFromYearSuspenseQueryHookResult = ReturnType<typeof useCampsFromYearSuspenseQuery>;
export type CampsFromYearQueryResult = Apollo.QueryResult<CampsFromYearQuery, CampsFromYearQueryVariables>;
export const CampDocument = gql`
    query camp($camp_id: Int!) {
  camp(camp_id: $camp_id) {
    ...AppCamp
  }
}
    ${AppCampFragmentDoc}`;

/**
 * __useCampQuery__
 *
 * To run a query within a React component, call `useCampQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function useCampQuery(baseOptions: Apollo.QueryHookOptions<CampQuery, CampQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampQuery, CampQueryVariables>(CampDocument, options);
      }
export function useCampLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampQuery, CampQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampQuery, CampQueryVariables>(CampDocument, options);
        }
export function useCampSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampQuery, CampQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampQuery, CampQueryVariables>(CampDocument, options);
        }
export type CampQueryHookResult = ReturnType<typeof useCampQuery>;
export type CampLazyQueryHookResult = ReturnType<typeof useCampLazyQuery>;
export type CampSuspenseQueryHookResult = ReturnType<typeof useCampSuspenseQuery>;
export type CampQueryResult = Apollo.QueryResult<CampQuery, CampQueryVariables>;
export const CreateCampDocument = gql`
    mutation createCamp($body: CampUpdate!) {
  createCamp(body: $body) {
    ...AppCamp
  }
}
    ${AppCampFragmentDoc}`;
export type CreateCampMutationFn = Apollo.MutationFunction<CreateCampMutation, CreateCampMutationVariables>;

/**
 * __useCreateCampMutation__
 *
 * To run a mutation, you first call `useCreateCampMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampMutation, { data, loading, error }] = useCreateCampMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateCampMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampMutation, CreateCampMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampMutation, CreateCampMutationVariables>(CreateCampDocument, options);
      }
export type CreateCampMutationHookResult = ReturnType<typeof useCreateCampMutation>;
export type CreateCampMutationResult = Apollo.MutationResult<CreateCampMutation>;
export type CreateCampMutationOptions = Apollo.BaseMutationOptions<CreateCampMutation, CreateCampMutationVariables>;
export const UpdateCampDocument = gql`
    mutation updateCamp($body: CampUpdate!) {
  updateCamp(body: $body) {
    ...AppCamp
  }
}
    ${AppCampFragmentDoc}`;
export type UpdateCampMutationFn = Apollo.MutationFunction<UpdateCampMutation, UpdateCampMutationVariables>;

/**
 * __useUpdateCampMutation__
 *
 * To run a mutation, you first call `useUpdateCampMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampMutation, { data, loading, error }] = useUpdateCampMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateCampMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampMutation, UpdateCampMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampMutation, UpdateCampMutationVariables>(UpdateCampDocument, options);
      }
export type UpdateCampMutationHookResult = ReturnType<typeof useUpdateCampMutation>;
export type UpdateCampMutationResult = Apollo.MutationResult<UpdateCampMutation>;
export type UpdateCampMutationOptions = Apollo.BaseMutationOptions<UpdateCampMutation, UpdateCampMutationVariables>;
export const ChurchLinkInfoBoxesDocument = gql`
    query churchLinkInfoBoxes($camp_id: Int!) {
  churchLinkInfoBoxes(camp_id: $camp_id) {
    ...AppInfoBox
  }
}
    ${AppInfoBoxFragmentDoc}`;

/**
 * __useChurchLinkInfoBoxesQuery__
 *
 * To run a query within a React component, call `useChurchLinkInfoBoxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChurchLinkInfoBoxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChurchLinkInfoBoxesQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function useChurchLinkInfoBoxesQuery(baseOptions: Apollo.QueryHookOptions<ChurchLinkInfoBoxesQuery, ChurchLinkInfoBoxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChurchLinkInfoBoxesQuery, ChurchLinkInfoBoxesQueryVariables>(ChurchLinkInfoBoxesDocument, options);
      }
export function useChurchLinkInfoBoxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChurchLinkInfoBoxesQuery, ChurchLinkInfoBoxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChurchLinkInfoBoxesQuery, ChurchLinkInfoBoxesQueryVariables>(ChurchLinkInfoBoxesDocument, options);
        }
export function useChurchLinkInfoBoxesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChurchLinkInfoBoxesQuery, ChurchLinkInfoBoxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChurchLinkInfoBoxesQuery, ChurchLinkInfoBoxesQueryVariables>(ChurchLinkInfoBoxesDocument, options);
        }
export type ChurchLinkInfoBoxesQueryHookResult = ReturnType<typeof useChurchLinkInfoBoxesQuery>;
export type ChurchLinkInfoBoxesLazyQueryHookResult = ReturnType<typeof useChurchLinkInfoBoxesLazyQuery>;
export type ChurchLinkInfoBoxesSuspenseQueryHookResult = ReturnType<typeof useChurchLinkInfoBoxesSuspenseQuery>;
export type ChurchLinkInfoBoxesQueryResult = Apollo.QueryResult<ChurchLinkInfoBoxesQuery, ChurchLinkInfoBoxesQueryVariables>;
export const AddChurchLinkInfoBoxDocument = gql`
    mutation addChurchLinkInfoBox($camp_id: Int!, $body: ChurchLinkInfoBoxInput!) {
  addChurchLinkInfoBox(camp_id: $camp_id, body: $body) {
    ...AppInfoBox
  }
}
    ${AppInfoBoxFragmentDoc}`;
export type AddChurchLinkInfoBoxMutationFn = Apollo.MutationFunction<AddChurchLinkInfoBoxMutation, AddChurchLinkInfoBoxMutationVariables>;

/**
 * __useAddChurchLinkInfoBoxMutation__
 *
 * To run a mutation, you first call `useAddChurchLinkInfoBoxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChurchLinkInfoBoxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChurchLinkInfoBoxMutation, { data, loading, error }] = useAddChurchLinkInfoBoxMutation({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useAddChurchLinkInfoBoxMutation(baseOptions?: Apollo.MutationHookOptions<AddChurchLinkInfoBoxMutation, AddChurchLinkInfoBoxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddChurchLinkInfoBoxMutation, AddChurchLinkInfoBoxMutationVariables>(AddChurchLinkInfoBoxDocument, options);
      }
export type AddChurchLinkInfoBoxMutationHookResult = ReturnType<typeof useAddChurchLinkInfoBoxMutation>;
export type AddChurchLinkInfoBoxMutationResult = Apollo.MutationResult<AddChurchLinkInfoBoxMutation>;
export type AddChurchLinkInfoBoxMutationOptions = Apollo.BaseMutationOptions<AddChurchLinkInfoBoxMutation, AddChurchLinkInfoBoxMutationVariables>;
export const UpdateChurchLinkInfoBoxDocument = gql`
    mutation updateChurchLinkInfoBox($id: Int!, $body: ChurchLinkInfoBoxInput!) {
  updateChurchLinkInfoBox(id: $id, body: $body) {
    ...AppInfoBox
  }
}
    ${AppInfoBoxFragmentDoc}`;
export type UpdateChurchLinkInfoBoxMutationFn = Apollo.MutationFunction<UpdateChurchLinkInfoBoxMutation, UpdateChurchLinkInfoBoxMutationVariables>;

/**
 * __useUpdateChurchLinkInfoBoxMutation__
 *
 * To run a mutation, you first call `useUpdateChurchLinkInfoBoxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChurchLinkInfoBoxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChurchLinkInfoBoxMutation, { data, loading, error }] = useUpdateChurchLinkInfoBoxMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateChurchLinkInfoBoxMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChurchLinkInfoBoxMutation, UpdateChurchLinkInfoBoxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChurchLinkInfoBoxMutation, UpdateChurchLinkInfoBoxMutationVariables>(UpdateChurchLinkInfoBoxDocument, options);
      }
export type UpdateChurchLinkInfoBoxMutationHookResult = ReturnType<typeof useUpdateChurchLinkInfoBoxMutation>;
export type UpdateChurchLinkInfoBoxMutationResult = Apollo.MutationResult<UpdateChurchLinkInfoBoxMutation>;
export type UpdateChurchLinkInfoBoxMutationOptions = Apollo.BaseMutationOptions<UpdateChurchLinkInfoBoxMutation, UpdateChurchLinkInfoBoxMutationVariables>;
export const DeleteChurchLinkInfoBoxDocument = gql`
    mutation deleteChurchLinkInfoBox($id: Int!) {
  deleteChurchLinkInfoBox(id: $id)
}
    `;
export type DeleteChurchLinkInfoBoxMutationFn = Apollo.MutationFunction<DeleteChurchLinkInfoBoxMutation, DeleteChurchLinkInfoBoxMutationVariables>;

/**
 * __useDeleteChurchLinkInfoBoxMutation__
 *
 * To run a mutation, you first call `useDeleteChurchLinkInfoBoxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChurchLinkInfoBoxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChurchLinkInfoBoxMutation, { data, loading, error }] = useDeleteChurchLinkInfoBoxMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChurchLinkInfoBoxMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChurchLinkInfoBoxMutation, DeleteChurchLinkInfoBoxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChurchLinkInfoBoxMutation, DeleteChurchLinkInfoBoxMutationVariables>(DeleteChurchLinkInfoBoxDocument, options);
      }
export type DeleteChurchLinkInfoBoxMutationHookResult = ReturnType<typeof useDeleteChurchLinkInfoBoxMutation>;
export type DeleteChurchLinkInfoBoxMutationResult = Apollo.MutationResult<DeleteChurchLinkInfoBoxMutation>;
export type DeleteChurchLinkInfoBoxMutationOptions = Apollo.BaseMutationOptions<DeleteChurchLinkInfoBoxMutation, DeleteChurchLinkInfoBoxMutationVariables>;
export const CampRolesDocument = gql`
    query CampRoles($camp_id: Int!) {
  campRoles(camp_id: $camp_id) {
    ...AppCampRole
  }
}
    ${AppCampRoleFragmentDoc}`;

/**
 * __useCampRolesQuery__
 *
 * To run a query within a React component, call `useCampRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampRolesQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function useCampRolesQuery(baseOptions: Apollo.QueryHookOptions<CampRolesQuery, CampRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampRolesQuery, CampRolesQueryVariables>(CampRolesDocument, options);
      }
export function useCampRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampRolesQuery, CampRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampRolesQuery, CampRolesQueryVariables>(CampRolesDocument, options);
        }
export function useCampRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampRolesQuery, CampRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampRolesQuery, CampRolesQueryVariables>(CampRolesDocument, options);
        }
export type CampRolesQueryHookResult = ReturnType<typeof useCampRolesQuery>;
export type CampRolesLazyQueryHookResult = ReturnType<typeof useCampRolesLazyQuery>;
export type CampRolesSuspenseQueryHookResult = ReturnType<typeof useCampRolesSuspenseQuery>;
export type CampRolesQueryResult = Apollo.QueryResult<CampRolesQuery, CampRolesQueryVariables>;
export const UpdateCampRoleDocument = gql`
    mutation updateCampRole($id: Int!, $input: CampRoleUpdate!) {
  updateCampRole(id: $id, input: $input) {
    ...AppCampRole
  }
}
    ${AppCampRoleFragmentDoc}`;
export type UpdateCampRoleMutationFn = Apollo.MutationFunction<UpdateCampRoleMutation, UpdateCampRoleMutationVariables>;

/**
 * __useUpdateCampRoleMutation__
 *
 * To run a mutation, you first call `useUpdateCampRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampRoleMutation, { data, loading, error }] = useUpdateCampRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampRoleMutation, UpdateCampRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampRoleMutation, UpdateCampRoleMutationVariables>(UpdateCampRoleDocument, options);
      }
export type UpdateCampRoleMutationHookResult = ReturnType<typeof useUpdateCampRoleMutation>;
export type UpdateCampRoleMutationResult = Apollo.MutationResult<UpdateCampRoleMutation>;
export type UpdateCampRoleMutationOptions = Apollo.BaseMutationOptions<UpdateCampRoleMutation, UpdateCampRoleMutationVariables>;
export const CreateMissingCampRolesDocument = gql`
    mutation createMissingCampRoles($camp_id: Int!) {
  createMissingCampRoles(camp_id: $camp_id) {
    ...AppCampRole
  }
}
    ${AppCampRoleFragmentDoc}`;
export type CreateMissingCampRolesMutationFn = Apollo.MutationFunction<CreateMissingCampRolesMutation, CreateMissingCampRolesMutationVariables>;

/**
 * __useCreateMissingCampRolesMutation__
 *
 * To run a mutation, you first call `useCreateMissingCampRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMissingCampRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMissingCampRolesMutation, { data, loading, error }] = useCreateMissingCampRolesMutation({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function useCreateMissingCampRolesMutation(baseOptions?: Apollo.MutationHookOptions<CreateMissingCampRolesMutation, CreateMissingCampRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMissingCampRolesMutation, CreateMissingCampRolesMutationVariables>(CreateMissingCampRolesDocument, options);
      }
export type CreateMissingCampRolesMutationHookResult = ReturnType<typeof useCreateMissingCampRolesMutation>;
export type CreateMissingCampRolesMutationResult = Apollo.MutationResult<CreateMissingCampRolesMutation>;
export type CreateMissingCampRolesMutationOptions = Apollo.BaseMutationOptions<CreateMissingCampRolesMutation, CreateMissingCampRolesMutationVariables>;
export const CampCollectionDocument = gql`
    query campCollection($collection: CampCollections!, $camp_id: Int!) {
  campCollection(collection: $collection, camp_id: $camp_id) {
    ...AppCampCollection
  }
}
    ${AppCampCollectionFragmentDoc}`;

/**
 * __useCampCollectionQuery__
 *
 * To run a query within a React component, call `useCampCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampCollectionQuery({
 *   variables: {
 *      collection: // value for 'collection'
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function useCampCollectionQuery(baseOptions: Apollo.QueryHookOptions<CampCollectionQuery, CampCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampCollectionQuery, CampCollectionQueryVariables>(CampCollectionDocument, options);
      }
export function useCampCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampCollectionQuery, CampCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampCollectionQuery, CampCollectionQueryVariables>(CampCollectionDocument, options);
        }
export function useCampCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampCollectionQuery, CampCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampCollectionQuery, CampCollectionQueryVariables>(CampCollectionDocument, options);
        }
export type CampCollectionQueryHookResult = ReturnType<typeof useCampCollectionQuery>;
export type CampCollectionLazyQueryHookResult = ReturnType<typeof useCampCollectionLazyQuery>;
export type CampCollectionSuspenseQueryHookResult = ReturnType<typeof useCampCollectionSuspenseQuery>;
export type CampCollectionQueryResult = Apollo.QueryResult<CampCollectionQuery, CampCollectionQueryVariables>;
export const UpdateCampCollectionDocument = gql`
    mutation updateCampCollection($collection: CampCollections!, $input: CampCollectionInput!) {
  updateCampCollection(collection: $collection, input: $input) {
    ...AppCampCollection
  }
}
    ${AppCampCollectionFragmentDoc}`;
export type UpdateCampCollectionMutationFn = Apollo.MutationFunction<UpdateCampCollectionMutation, UpdateCampCollectionMutationVariables>;

/**
 * __useUpdateCampCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCampCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampCollectionMutation, { data, loading, error }] = useUpdateCampCollectionMutation({
 *   variables: {
 *      collection: // value for 'collection'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampCollectionMutation, UpdateCampCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampCollectionMutation, UpdateCampCollectionMutationVariables>(UpdateCampCollectionDocument, options);
      }
export type UpdateCampCollectionMutationHookResult = ReturnType<typeof useUpdateCampCollectionMutation>;
export type UpdateCampCollectionMutationResult = Apollo.MutationResult<UpdateCampCollectionMutation>;
export type UpdateCampCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateCampCollectionMutation, UpdateCampCollectionMutationVariables>;
export const AddCampCollectionItemsDocument = gql`
    mutation addCampCollectionItems($collection: CampCollections!, $input: [CampCollectionInput]!) {
  addCampCollectionItems(collection: $collection, input: $input) {
    ...AppCampCollection
  }
}
    ${AppCampCollectionFragmentDoc}`;
export type AddCampCollectionItemsMutationFn = Apollo.MutationFunction<AddCampCollectionItemsMutation, AddCampCollectionItemsMutationVariables>;

/**
 * __useAddCampCollectionItemsMutation__
 *
 * To run a mutation, you first call `useAddCampCollectionItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCampCollectionItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCampCollectionItemsMutation, { data, loading, error }] = useAddCampCollectionItemsMutation({
 *   variables: {
 *      collection: // value for 'collection'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCampCollectionItemsMutation(baseOptions?: Apollo.MutationHookOptions<AddCampCollectionItemsMutation, AddCampCollectionItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCampCollectionItemsMutation, AddCampCollectionItemsMutationVariables>(AddCampCollectionItemsDocument, options);
      }
export type AddCampCollectionItemsMutationHookResult = ReturnType<typeof useAddCampCollectionItemsMutation>;
export type AddCampCollectionItemsMutationResult = Apollo.MutationResult<AddCampCollectionItemsMutation>;
export type AddCampCollectionItemsMutationOptions = Apollo.BaseMutationOptions<AddCampCollectionItemsMutation, AddCampCollectionItemsMutationVariables>;
export const DeleteCampCollectionItemDocument = gql`
    mutation deleteCampCollectionItem($collection: CampCollections!, $id: Int!) {
  deleteCampCollectionItem(collection: $collection, id: $id)
}
    `;
export type DeleteCampCollectionItemMutationFn = Apollo.MutationFunction<DeleteCampCollectionItemMutation, DeleteCampCollectionItemMutationVariables>;

/**
 * __useDeleteCampCollectionItemMutation__
 *
 * To run a mutation, you first call `useDeleteCampCollectionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampCollectionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampCollectionItemMutation, { data, loading, error }] = useDeleteCampCollectionItemMutation({
 *   variables: {
 *      collection: // value for 'collection'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCampCollectionItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampCollectionItemMutation, DeleteCampCollectionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampCollectionItemMutation, DeleteCampCollectionItemMutationVariables>(DeleteCampCollectionItemDocument, options);
      }
export type DeleteCampCollectionItemMutationHookResult = ReturnType<typeof useDeleteCampCollectionItemMutation>;
export type DeleteCampCollectionItemMutationResult = Apollo.MutationResult<DeleteCampCollectionItemMutation>;
export type DeleteCampCollectionItemMutationOptions = Apollo.BaseMutationOptions<DeleteCampCollectionItemMutation, DeleteCampCollectionItemMutationVariables>;
export const CampCollectionsDocument = gql`
    query campCollections($camp_id: Int!) {
  campCollections(camp_id: $camp_id)
}
    `;

/**
 * __useCampCollectionsQuery__
 *
 * To run a query within a React component, call `useCampCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampCollectionsQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function useCampCollectionsQuery(baseOptions: Apollo.QueryHookOptions<CampCollectionsQuery, CampCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampCollectionsQuery, CampCollectionsQueryVariables>(CampCollectionsDocument, options);
      }
export function useCampCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampCollectionsQuery, CampCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampCollectionsQuery, CampCollectionsQueryVariables>(CampCollectionsDocument, options);
        }
export function useCampCollectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampCollectionsQuery, CampCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampCollectionsQuery, CampCollectionsQueryVariables>(CampCollectionsDocument, options);
        }
export type CampCollectionsQueryHookResult = ReturnType<typeof useCampCollectionsQuery>;
export type CampCollectionsLazyQueryHookResult = ReturnType<typeof useCampCollectionsLazyQuery>;
export type CampCollectionsSuspenseQueryHookResult = ReturnType<typeof useCampCollectionsSuspenseQuery>;
export type CampCollectionsQueryResult = Apollo.QueryResult<CampCollectionsQuery, CampCollectionsQueryVariables>;
export const CampColumnsDocument = gql`
    query CampColumns($camp_id: Int!) {
  campColumns(camp_id: $camp_id) {
    ...AppCampColumn
  }
}
    ${AppCampColumnFragmentDoc}`;

/**
 * __useCampColumnsQuery__
 *
 * To run a query within a React component, call `useCampColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampColumnsQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function useCampColumnsQuery(baseOptions: Apollo.QueryHookOptions<CampColumnsQuery, CampColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampColumnsQuery, CampColumnsQueryVariables>(CampColumnsDocument, options);
      }
export function useCampColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampColumnsQuery, CampColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampColumnsQuery, CampColumnsQueryVariables>(CampColumnsDocument, options);
        }
export function useCampColumnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampColumnsQuery, CampColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampColumnsQuery, CampColumnsQueryVariables>(CampColumnsDocument, options);
        }
export type CampColumnsQueryHookResult = ReturnType<typeof useCampColumnsQuery>;
export type CampColumnsLazyQueryHookResult = ReturnType<typeof useCampColumnsLazyQuery>;
export type CampColumnsSuspenseQueryHookResult = ReturnType<typeof useCampColumnsSuspenseQuery>;
export type CampColumnsQueryResult = Apollo.QueryResult<CampColumnsQuery, CampColumnsQueryVariables>;
export const CreateCampColumnDocument = gql`
    mutation createCampColumn($camp_id: Int!, $details: JSONObject) {
  createCampColumn(camp_id: $camp_id, details: $details) {
    ...AppCampColumn
  }
}
    ${AppCampColumnFragmentDoc}`;
export type CreateCampColumnMutationFn = Apollo.MutationFunction<CreateCampColumnMutation, CreateCampColumnMutationVariables>;

/**
 * __useCreateCampColumnMutation__
 *
 * To run a mutation, you first call `useCreateCampColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampColumnMutation, { data, loading, error }] = useCreateCampColumnMutation({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useCreateCampColumnMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampColumnMutation, CreateCampColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampColumnMutation, CreateCampColumnMutationVariables>(CreateCampColumnDocument, options);
      }
export type CreateCampColumnMutationHookResult = ReturnType<typeof useCreateCampColumnMutation>;
export type CreateCampColumnMutationResult = Apollo.MutationResult<CreateCampColumnMutation>;
export type CreateCampColumnMutationOptions = Apollo.BaseMutationOptions<CreateCampColumnMutation, CreateCampColumnMutationVariables>;
export const UpdateCampColumnDocument = gql`
    mutation updateCampColumn($id: Int!, $details: JSONObject) {
  updateCampColumn(id: $id, details: $details) {
    ...AppCampColumn
  }
}
    ${AppCampColumnFragmentDoc}`;
export type UpdateCampColumnMutationFn = Apollo.MutationFunction<UpdateCampColumnMutation, UpdateCampColumnMutationVariables>;

/**
 * __useUpdateCampColumnMutation__
 *
 * To run a mutation, you first call `useUpdateCampColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampColumnMutation, { data, loading, error }] = useUpdateCampColumnMutation({
 *   variables: {
 *      id: // value for 'id'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUpdateCampColumnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampColumnMutation, UpdateCampColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampColumnMutation, UpdateCampColumnMutationVariables>(UpdateCampColumnDocument, options);
      }
export type UpdateCampColumnMutationHookResult = ReturnType<typeof useUpdateCampColumnMutation>;
export type UpdateCampColumnMutationResult = Apollo.MutationResult<UpdateCampColumnMutation>;
export type UpdateCampColumnMutationOptions = Apollo.BaseMutationOptions<UpdateCampColumnMutation, UpdateCampColumnMutationVariables>;
export const UpdateGdprDaysDocument = gql`
    mutation updateGdprDays($camp_id: Int!, $columnsObject: JSONObject) {
  updateGdprDays(camp_id: $camp_id, columnsObject: $columnsObject) {
    ...AppCampColumn
  }
}
    ${AppCampColumnFragmentDoc}`;
export type UpdateGdprDaysMutationFn = Apollo.MutationFunction<UpdateGdprDaysMutation, UpdateGdprDaysMutationVariables>;

/**
 * __useUpdateGdprDaysMutation__
 *
 * To run a mutation, you first call `useUpdateGdprDaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGdprDaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGdprDaysMutation, { data, loading, error }] = useUpdateGdprDaysMutation({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *      columnsObject: // value for 'columnsObject'
 *   },
 * });
 */
export function useUpdateGdprDaysMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGdprDaysMutation, UpdateGdprDaysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGdprDaysMutation, UpdateGdprDaysMutationVariables>(UpdateGdprDaysDocument, options);
      }
export type UpdateGdprDaysMutationHookResult = ReturnType<typeof useUpdateGdprDaysMutation>;
export type UpdateGdprDaysMutationResult = Apollo.MutationResult<UpdateGdprDaysMutation>;
export type UpdateGdprDaysMutationOptions = Apollo.BaseMutationOptions<UpdateGdprDaysMutation, UpdateGdprDaysMutationVariables>;
export const DeleteCampColumnDocument = gql`
    mutation deleteCampColumn($id: Int!) {
  deleteCampColumn(id: $id)
}
    `;
export type DeleteCampColumnMutationFn = Apollo.MutationFunction<DeleteCampColumnMutation, DeleteCampColumnMutationVariables>;

/**
 * __useDeleteCampColumnMutation__
 *
 * To run a mutation, you first call `useDeleteCampColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampColumnMutation, { data, loading, error }] = useDeleteCampColumnMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCampColumnMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampColumnMutation, DeleteCampColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampColumnMutation, DeleteCampColumnMutationVariables>(DeleteCampColumnDocument, options);
      }
export type DeleteCampColumnMutationHookResult = ReturnType<typeof useDeleteCampColumnMutation>;
export type DeleteCampColumnMutationResult = Apollo.MutationResult<DeleteCampColumnMutation>;
export type DeleteCampColumnMutationOptions = Apollo.BaseMutationOptions<DeleteCampColumnMutation, DeleteCampColumnMutationVariables>;
export const CampTimeTableDocument = gql`
    query CampTimeTable($card_id: Int!) {
  campTimeTable(card_id: $card_id) {
    ...AppTimeTable
  }
}
    ${AppTimeTableFragmentDoc}`;

/**
 * __useCampTimeTableQuery__
 *
 * To run a query within a React component, call `useCampTimeTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampTimeTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampTimeTableQuery({
 *   variables: {
 *      card_id: // value for 'card_id'
 *   },
 * });
 */
export function useCampTimeTableQuery(baseOptions: Apollo.QueryHookOptions<CampTimeTableQuery, CampTimeTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampTimeTableQuery, CampTimeTableQueryVariables>(CampTimeTableDocument, options);
      }
export function useCampTimeTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampTimeTableQuery, CampTimeTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampTimeTableQuery, CampTimeTableQueryVariables>(CampTimeTableDocument, options);
        }
export function useCampTimeTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampTimeTableQuery, CampTimeTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampTimeTableQuery, CampTimeTableQueryVariables>(CampTimeTableDocument, options);
        }
export type CampTimeTableQueryHookResult = ReturnType<typeof useCampTimeTableQuery>;
export type CampTimeTableLazyQueryHookResult = ReturnType<typeof useCampTimeTableLazyQuery>;
export type CampTimeTableSuspenseQueryHookResult = ReturnType<typeof useCampTimeTableSuspenseQuery>;
export type CampTimeTableQueryResult = Apollo.QueryResult<CampTimeTableQuery, CampTimeTableQueryVariables>;
export const CreateTimeTableEntryDocument = gql`
    mutation createTimeTableEntry($timeTableEntry: TimeTableInput!) {
  createTimeTableEntry(body: $timeTableEntry) {
    ...AppTimeTable
  }
}
    ${AppTimeTableFragmentDoc}`;
export type CreateTimeTableEntryMutationFn = Apollo.MutationFunction<CreateTimeTableEntryMutation, CreateTimeTableEntryMutationVariables>;

/**
 * __useCreateTimeTableEntryMutation__
 *
 * To run a mutation, you first call `useCreateTimeTableEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeTableEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeTableEntryMutation, { data, loading, error }] = useCreateTimeTableEntryMutation({
 *   variables: {
 *      timeTableEntry: // value for 'timeTableEntry'
 *   },
 * });
 */
export function useCreateTimeTableEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeTableEntryMutation, CreateTimeTableEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeTableEntryMutation, CreateTimeTableEntryMutationVariables>(CreateTimeTableEntryDocument, options);
      }
export type CreateTimeTableEntryMutationHookResult = ReturnType<typeof useCreateTimeTableEntryMutation>;
export type CreateTimeTableEntryMutationResult = Apollo.MutationResult<CreateTimeTableEntryMutation>;
export type CreateTimeTableEntryMutationOptions = Apollo.BaseMutationOptions<CreateTimeTableEntryMutation, CreateTimeTableEntryMutationVariables>;
export const UpdateTimeTableEntryDocument = gql`
    mutation updateTimeTableEntry($body: TimeTableUpdate) {
  updateTimeTableEntry(body: $body) {
    ...AppTimeTable
  }
}
    ${AppTimeTableFragmentDoc}`;
export type UpdateTimeTableEntryMutationFn = Apollo.MutationFunction<UpdateTimeTableEntryMutation, UpdateTimeTableEntryMutationVariables>;

/**
 * __useUpdateTimeTableEntryMutation__
 *
 * To run a mutation, you first call `useUpdateTimeTableEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeTableEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeTableEntryMutation, { data, loading, error }] = useUpdateTimeTableEntryMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateTimeTableEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeTableEntryMutation, UpdateTimeTableEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeTableEntryMutation, UpdateTimeTableEntryMutationVariables>(UpdateTimeTableEntryDocument, options);
      }
export type UpdateTimeTableEntryMutationHookResult = ReturnType<typeof useUpdateTimeTableEntryMutation>;
export type UpdateTimeTableEntryMutationResult = Apollo.MutationResult<UpdateTimeTableEntryMutation>;
export type UpdateTimeTableEntryMutationOptions = Apollo.BaseMutationOptions<UpdateTimeTableEntryMutation, UpdateTimeTableEntryMutationVariables>;
export const DeleteTimeTableEntryDocument = gql`
    mutation deleteTimeTableEntry($card_id: Int!, $timeTableId: String!) {
  deleteTimeTableEntry(card_id: $card_id, timeTableId: $timeTableId)
}
    `;
export type DeleteTimeTableEntryMutationFn = Apollo.MutationFunction<DeleteTimeTableEntryMutation, DeleteTimeTableEntryMutationVariables>;

/**
 * __useDeleteTimeTableEntryMutation__
 *
 * To run a mutation, you first call `useDeleteTimeTableEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeTableEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeTableEntryMutation, { data, loading, error }] = useDeleteTimeTableEntryMutation({
 *   variables: {
 *      card_id: // value for 'card_id'
 *      timeTableId: // value for 'timeTableId'
 *   },
 * });
 */
export function useDeleteTimeTableEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeTableEntryMutation, DeleteTimeTableEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeTableEntryMutation, DeleteTimeTableEntryMutationVariables>(DeleteTimeTableEntryDocument, options);
      }
export type DeleteTimeTableEntryMutationHookResult = ReturnType<typeof useDeleteTimeTableEntryMutation>;
export type DeleteTimeTableEntryMutationResult = Apollo.MutationResult<DeleteTimeTableEntryMutation>;
export type DeleteTimeTableEntryMutationOptions = Apollo.BaseMutationOptions<DeleteTimeTableEntryMutation, DeleteTimeTableEntryMutationVariables>;
export const CampContactsDocument = gql`
    query CampContacts($card_id: Int!) {
  campContacts(card_id: $card_id) {
    ...AppCampContact
  }
}
    ${AppCampContactFragmentDoc}`;

/**
 * __useCampContactsQuery__
 *
 * To run a query within a React component, call `useCampContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampContactsQuery({
 *   variables: {
 *      card_id: // value for 'card_id'
 *   },
 * });
 */
export function useCampContactsQuery(baseOptions: Apollo.QueryHookOptions<CampContactsQuery, CampContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampContactsQuery, CampContactsQueryVariables>(CampContactsDocument, options);
      }
export function useCampContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampContactsQuery, CampContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampContactsQuery, CampContactsQueryVariables>(CampContactsDocument, options);
        }
export function useCampContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampContactsQuery, CampContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampContactsQuery, CampContactsQueryVariables>(CampContactsDocument, options);
        }
export type CampContactsQueryHookResult = ReturnType<typeof useCampContactsQuery>;
export type CampContactsLazyQueryHookResult = ReturnType<typeof useCampContactsLazyQuery>;
export type CampContactsSuspenseQueryHookResult = ReturnType<typeof useCampContactsSuspenseQuery>;
export type CampContactsQueryResult = Apollo.QueryResult<CampContactsQuery, CampContactsQueryVariables>;
export const CreateCampContactDocument = gql`
    mutation createCampContact($campContact: CampContactInput!) {
  createCampContact(body: $campContact) {
    ...AppCampContact
  }
}
    ${AppCampContactFragmentDoc}`;
export type CreateCampContactMutationFn = Apollo.MutationFunction<CreateCampContactMutation, CreateCampContactMutationVariables>;

/**
 * __useCreateCampContactMutation__
 *
 * To run a mutation, you first call `useCreateCampContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampContactMutation, { data, loading, error }] = useCreateCampContactMutation({
 *   variables: {
 *      campContact: // value for 'campContact'
 *   },
 * });
 */
export function useCreateCampContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampContactMutation, CreateCampContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampContactMutation, CreateCampContactMutationVariables>(CreateCampContactDocument, options);
      }
export type CreateCampContactMutationHookResult = ReturnType<typeof useCreateCampContactMutation>;
export type CreateCampContactMutationResult = Apollo.MutationResult<CreateCampContactMutation>;
export type CreateCampContactMutationOptions = Apollo.BaseMutationOptions<CreateCampContactMutation, CreateCampContactMutationVariables>;
export const UpdateCampContactDocument = gql`
    mutation updateCampContact($campContact: CampContactUpdate) {
  updateCampContact(body: $campContact) {
    ...AppCampContact
  }
}
    ${AppCampContactFragmentDoc}`;
export type UpdateCampContactMutationFn = Apollo.MutationFunction<UpdateCampContactMutation, UpdateCampContactMutationVariables>;

/**
 * __useUpdateCampContactMutation__
 *
 * To run a mutation, you first call `useUpdateCampContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampContactMutation, { data, loading, error }] = useUpdateCampContactMutation({
 *   variables: {
 *      campContact: // value for 'campContact'
 *   },
 * });
 */
export function useUpdateCampContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampContactMutation, UpdateCampContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampContactMutation, UpdateCampContactMutationVariables>(UpdateCampContactDocument, options);
      }
export type UpdateCampContactMutationHookResult = ReturnType<typeof useUpdateCampContactMutation>;
export type UpdateCampContactMutationResult = Apollo.MutationResult<UpdateCampContactMutation>;
export type UpdateCampContactMutationOptions = Apollo.BaseMutationOptions<UpdateCampContactMutation, UpdateCampContactMutationVariables>;
export const DeleteCampContactDocument = gql`
    mutation deleteCampContact($card_id: Int!, $campContactId: String!) {
  deleteCampContact(card_id: $card_id, campContactId: $campContactId)
}
    `;
export type DeleteCampContactMutationFn = Apollo.MutationFunction<DeleteCampContactMutation, DeleteCampContactMutationVariables>;

/**
 * __useDeleteCampContactMutation__
 *
 * To run a mutation, you first call `useDeleteCampContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampContactMutation, { data, loading, error }] = useDeleteCampContactMutation({
 *   variables: {
 *      card_id: // value for 'card_id'
 *      campContactId: // value for 'campContactId'
 *   },
 * });
 */
export function useDeleteCampContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampContactMutation, DeleteCampContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampContactMutation, DeleteCampContactMutationVariables>(DeleteCampContactDocument, options);
      }
export type DeleteCampContactMutationHookResult = ReturnType<typeof useDeleteCampContactMutation>;
export type DeleteCampContactMutationResult = Apollo.MutationResult<DeleteCampContactMutation>;
export type DeleteCampContactMutationOptions = Apollo.BaseMutationOptions<DeleteCampContactMutation, DeleteCampContactMutationVariables>;
export const CampPermissionDocument = gql`
    query CampPermission($camp_id: Int!) {
  campPermissions(camp_id: $camp_id) {
    ...AppCampPermission
  }
}
    ${AppCampPermissionFragmentDoc}`;

/**
 * __useCampPermissionQuery__
 *
 * To run a query within a React component, call `useCampPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampPermissionQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function useCampPermissionQuery(baseOptions: Apollo.QueryHookOptions<CampPermissionQuery, CampPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampPermissionQuery, CampPermissionQueryVariables>(CampPermissionDocument, options);
      }
export function useCampPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampPermissionQuery, CampPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampPermissionQuery, CampPermissionQueryVariables>(CampPermissionDocument, options);
        }
export function useCampPermissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampPermissionQuery, CampPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampPermissionQuery, CampPermissionQueryVariables>(CampPermissionDocument, options);
        }
export type CampPermissionQueryHookResult = ReturnType<typeof useCampPermissionQuery>;
export type CampPermissionLazyQueryHookResult = ReturnType<typeof useCampPermissionLazyQuery>;
export type CampPermissionSuspenseQueryHookResult = ReturnType<typeof useCampPermissionSuspenseQuery>;
export type CampPermissionQueryResult = Apollo.QueryResult<CampPermissionQuery, CampPermissionQueryVariables>;
export const CreateCampPermissionDocument = gql`
    mutation createCampPermission($campPermission: CampPermissionInput!) {
  createCampPermission(body: $campPermission) {
    ...AppCampPermission
  }
}
    ${AppCampPermissionFragmentDoc}`;
export type CreateCampPermissionMutationFn = Apollo.MutationFunction<CreateCampPermissionMutation, CreateCampPermissionMutationVariables>;

/**
 * __useCreateCampPermissionMutation__
 *
 * To run a mutation, you first call `useCreateCampPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampPermissionMutation, { data, loading, error }] = useCreateCampPermissionMutation({
 *   variables: {
 *      campPermission: // value for 'campPermission'
 *   },
 * });
 */
export function useCreateCampPermissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampPermissionMutation, CreateCampPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampPermissionMutation, CreateCampPermissionMutationVariables>(CreateCampPermissionDocument, options);
      }
export type CreateCampPermissionMutationHookResult = ReturnType<typeof useCreateCampPermissionMutation>;
export type CreateCampPermissionMutationResult = Apollo.MutationResult<CreateCampPermissionMutation>;
export type CreateCampPermissionMutationOptions = Apollo.BaseMutationOptions<CreateCampPermissionMutation, CreateCampPermissionMutationVariables>;
export const UpdateCampPermissionDocument = gql`
    mutation updateCampPermission($campPermission: CampPermissionUpdate!) {
  updateCampPermission(body: $campPermission) {
    ...AppCampPermission
  }
}
    ${AppCampPermissionFragmentDoc}`;
export type UpdateCampPermissionMutationFn = Apollo.MutationFunction<UpdateCampPermissionMutation, UpdateCampPermissionMutationVariables>;

/**
 * __useUpdateCampPermissionMutation__
 *
 * To run a mutation, you first call `useUpdateCampPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampPermissionMutation, { data, loading, error }] = useUpdateCampPermissionMutation({
 *   variables: {
 *      campPermission: // value for 'campPermission'
 *   },
 * });
 */
export function useUpdateCampPermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampPermissionMutation, UpdateCampPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampPermissionMutation, UpdateCampPermissionMutationVariables>(UpdateCampPermissionDocument, options);
      }
export type UpdateCampPermissionMutationHookResult = ReturnType<typeof useUpdateCampPermissionMutation>;
export type UpdateCampPermissionMutationResult = Apollo.MutationResult<UpdateCampPermissionMutation>;
export type UpdateCampPermissionMutationOptions = Apollo.BaseMutationOptions<UpdateCampPermissionMutation, UpdateCampPermissionMutationVariables>;
export const DeleteCampPermissionDocument = gql`
    mutation deleteCampPermission($camp_id: Int!, $campPermissionId: Int!) {
  deleteCampPermission(camp_id: $camp_id, campPermissionId: $campPermissionId)
}
    `;
export type DeleteCampPermissionMutationFn = Apollo.MutationFunction<DeleteCampPermissionMutation, DeleteCampPermissionMutationVariables>;

/**
 * __useDeleteCampPermissionMutation__
 *
 * To run a mutation, you first call `useDeleteCampPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampPermissionMutation, { data, loading, error }] = useDeleteCampPermissionMutation({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *      campPermissionId: // value for 'campPermissionId'
 *   },
 * });
 */
export function useDeleteCampPermissionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampPermissionMutation, DeleteCampPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampPermissionMutation, DeleteCampPermissionMutationVariables>(DeleteCampPermissionDocument, options);
      }
export type DeleteCampPermissionMutationHookResult = ReturnType<typeof useDeleteCampPermissionMutation>;
export type DeleteCampPermissionMutationResult = Apollo.MutationResult<DeleteCampPermissionMutation>;
export type DeleteCampPermissionMutationOptions = Apollo.BaseMutationOptions<DeleteCampPermissionMutation, DeleteCampPermissionMutationVariables>;
export const AppCardsDocument = gql`
    query appCards($event_id: Int!) {
  appCards(event_id: $event_id) {
    ...AppAppCard
  }
}
    ${AppAppCardFragmentDoc}`;

/**
 * __useAppCardsQuery__
 *
 * To run a query within a React component, call `useAppCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppCardsQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useAppCardsQuery(baseOptions: Apollo.QueryHookOptions<AppCardsQuery, AppCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppCardsQuery, AppCardsQueryVariables>(AppCardsDocument, options);
      }
export function useAppCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppCardsQuery, AppCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppCardsQuery, AppCardsQueryVariables>(AppCardsDocument, options);
        }
export function useAppCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppCardsQuery, AppCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppCardsQuery, AppCardsQueryVariables>(AppCardsDocument, options);
        }
export type AppCardsQueryHookResult = ReturnType<typeof useAppCardsQuery>;
export type AppCardsLazyQueryHookResult = ReturnType<typeof useAppCardsLazyQuery>;
export type AppCardsSuspenseQueryHookResult = ReturnType<typeof useAppCardsSuspenseQuery>;
export type AppCardsQueryResult = Apollo.QueryResult<AppCardsQuery, AppCardsQueryVariables>;
export const CreateAppCardDocument = gql`
    mutation createAppCard($appCard: AppCardInput!) {
  createAppCard(body: $appCard) {
    ...AppAppCard
  }
}
    ${AppAppCardFragmentDoc}`;
export type CreateAppCardMutationFn = Apollo.MutationFunction<CreateAppCardMutation, CreateAppCardMutationVariables>;

/**
 * __useCreateAppCardMutation__
 *
 * To run a mutation, you first call `useCreateAppCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppCardMutation, { data, loading, error }] = useCreateAppCardMutation({
 *   variables: {
 *      appCard: // value for 'appCard'
 *   },
 * });
 */
export function useCreateAppCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppCardMutation, CreateAppCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppCardMutation, CreateAppCardMutationVariables>(CreateAppCardDocument, options);
      }
export type CreateAppCardMutationHookResult = ReturnType<typeof useCreateAppCardMutation>;
export type CreateAppCardMutationResult = Apollo.MutationResult<CreateAppCardMutation>;
export type CreateAppCardMutationOptions = Apollo.BaseMutationOptions<CreateAppCardMutation, CreateAppCardMutationVariables>;
export const UpdateAppCardDocument = gql`
    mutation updateAppCard($appCard: AppCardUpdate!) {
  updateAppCard(body: $appCard) {
    ...AppAppCard
  }
}
    ${AppAppCardFragmentDoc}`;
export type UpdateAppCardMutationFn = Apollo.MutationFunction<UpdateAppCardMutation, UpdateAppCardMutationVariables>;

/**
 * __useUpdateAppCardMutation__
 *
 * To run a mutation, you first call `useUpdateAppCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppCardMutation, { data, loading, error }] = useUpdateAppCardMutation({
 *   variables: {
 *      appCard: // value for 'appCard'
 *   },
 * });
 */
export function useUpdateAppCardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppCardMutation, UpdateAppCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppCardMutation, UpdateAppCardMutationVariables>(UpdateAppCardDocument, options);
      }
export type UpdateAppCardMutationHookResult = ReturnType<typeof useUpdateAppCardMutation>;
export type UpdateAppCardMutationResult = Apollo.MutationResult<UpdateAppCardMutation>;
export type UpdateAppCardMutationOptions = Apollo.BaseMutationOptions<UpdateAppCardMutation, UpdateAppCardMutationVariables>;
export const DeleteAppCardDocument = gql`
    mutation deleteAppCard($id: Int!, $event_id: Int!) {
  deleteAppCard(id: $id, event_id: $event_id)
}
    `;
export type DeleteAppCardMutationFn = Apollo.MutationFunction<DeleteAppCardMutation, DeleteAppCardMutationVariables>;

/**
 * __useDeleteAppCardMutation__
 *
 * To run a mutation, you first call `useDeleteAppCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppCardMutation, { data, loading, error }] = useDeleteAppCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useDeleteAppCardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAppCardMutation, DeleteAppCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAppCardMutation, DeleteAppCardMutationVariables>(DeleteAppCardDocument, options);
      }
export type DeleteAppCardMutationHookResult = ReturnType<typeof useDeleteAppCardMutation>;
export type DeleteAppCardMutationResult = Apollo.MutationResult<DeleteAppCardMutation>;
export type DeleteAppCardMutationOptions = Apollo.BaseMutationOptions<DeleteAppCardMutation, DeleteAppCardMutationVariables>;
export const AppSchedulesDocument = gql`
    query appSchedules($card_id: Int!) {
  appSchedules(card_id: $card_id) {
    ...AppAppSchedule
  }
}
    ${AppAppScheduleFragmentDoc}`;

/**
 * __useAppSchedulesQuery__
 *
 * To run a query within a React component, call `useAppSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppSchedulesQuery({
 *   variables: {
 *      card_id: // value for 'card_id'
 *   },
 * });
 */
export function useAppSchedulesQuery(baseOptions: Apollo.QueryHookOptions<AppSchedulesQuery, AppSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppSchedulesQuery, AppSchedulesQueryVariables>(AppSchedulesDocument, options);
      }
export function useAppSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppSchedulesQuery, AppSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppSchedulesQuery, AppSchedulesQueryVariables>(AppSchedulesDocument, options);
        }
export function useAppSchedulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppSchedulesQuery, AppSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppSchedulesQuery, AppSchedulesQueryVariables>(AppSchedulesDocument, options);
        }
export type AppSchedulesQueryHookResult = ReturnType<typeof useAppSchedulesQuery>;
export type AppSchedulesLazyQueryHookResult = ReturnType<typeof useAppSchedulesLazyQuery>;
export type AppSchedulesSuspenseQueryHookResult = ReturnType<typeof useAppSchedulesSuspenseQuery>;
export type AppSchedulesQueryResult = Apollo.QueryResult<AppSchedulesQuery, AppSchedulesQueryVariables>;
export const CreateAppScheduleDocument = gql`
    mutation createAppSchedule($appSchedule: AppScheduleInput!) {
  createAppSchedule(body: $appSchedule) {
    ...AppAppSchedule
  }
}
    ${AppAppScheduleFragmentDoc}`;
export type CreateAppScheduleMutationFn = Apollo.MutationFunction<CreateAppScheduleMutation, CreateAppScheduleMutationVariables>;

/**
 * __useCreateAppScheduleMutation__
 *
 * To run a mutation, you first call `useCreateAppScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppScheduleMutation, { data, loading, error }] = useCreateAppScheduleMutation({
 *   variables: {
 *      appSchedule: // value for 'appSchedule'
 *   },
 * });
 */
export function useCreateAppScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppScheduleMutation, CreateAppScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppScheduleMutation, CreateAppScheduleMutationVariables>(CreateAppScheduleDocument, options);
      }
export type CreateAppScheduleMutationHookResult = ReturnType<typeof useCreateAppScheduleMutation>;
export type CreateAppScheduleMutationResult = Apollo.MutationResult<CreateAppScheduleMutation>;
export type CreateAppScheduleMutationOptions = Apollo.BaseMutationOptions<CreateAppScheduleMutation, CreateAppScheduleMutationVariables>;
export const UpdateAppScheduleDocument = gql`
    mutation updateAppSchedule($appSchedule: AppScheduleUpdate!) {
  updateAppSchedule(body: $appSchedule) {
    ...AppAppSchedule
  }
}
    ${AppAppScheduleFragmentDoc}`;
export type UpdateAppScheduleMutationFn = Apollo.MutationFunction<UpdateAppScheduleMutation, UpdateAppScheduleMutationVariables>;

/**
 * __useUpdateAppScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateAppScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppScheduleMutation, { data, loading, error }] = useUpdateAppScheduleMutation({
 *   variables: {
 *      appSchedule: // value for 'appSchedule'
 *   },
 * });
 */
export function useUpdateAppScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppScheduleMutation, UpdateAppScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppScheduleMutation, UpdateAppScheduleMutationVariables>(UpdateAppScheduleDocument, options);
      }
export type UpdateAppScheduleMutationHookResult = ReturnType<typeof useUpdateAppScheduleMutation>;
export type UpdateAppScheduleMutationResult = Apollo.MutationResult<UpdateAppScheduleMutation>;
export type UpdateAppScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateAppScheduleMutation, UpdateAppScheduleMutationVariables>;
export const DeleteAppScheduleDocument = gql`
    mutation deleteAppSchedule($id: Int!) {
  deleteAppSchedule(id: $id)
}
    `;
export type DeleteAppScheduleMutationFn = Apollo.MutationFunction<DeleteAppScheduleMutation, DeleteAppScheduleMutationVariables>;

/**
 * __useDeleteAppScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteAppScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppScheduleMutation, { data, loading, error }] = useDeleteAppScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAppScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAppScheduleMutation, DeleteAppScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAppScheduleMutation, DeleteAppScheduleMutationVariables>(DeleteAppScheduleDocument, options);
      }
export type DeleteAppScheduleMutationHookResult = ReturnType<typeof useDeleteAppScheduleMutation>;
export type DeleteAppScheduleMutationResult = Apollo.MutationResult<DeleteAppScheduleMutation>;
export type DeleteAppScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteAppScheduleMutation, DeleteAppScheduleMutationVariables>;
export const CampChurchesDocument = gql`
    query campChurches($camp_id: Int!) {
  campChurches(camp_id: $camp_id) {
    ...AppCampChurch
  }
}
    ${AppCampChurchFragmentDoc}`;

/**
 * __useCampChurchesQuery__
 *
 * To run a query within a React component, call `useCampChurchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampChurchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampChurchesQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function useCampChurchesQuery(baseOptions: Apollo.QueryHookOptions<CampChurchesQuery, CampChurchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampChurchesQuery, CampChurchesQueryVariables>(CampChurchesDocument, options);
      }
export function useCampChurchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampChurchesQuery, CampChurchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampChurchesQuery, CampChurchesQueryVariables>(CampChurchesDocument, options);
        }
export function useCampChurchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampChurchesQuery, CampChurchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampChurchesQuery, CampChurchesQueryVariables>(CampChurchesDocument, options);
        }
export type CampChurchesQueryHookResult = ReturnType<typeof useCampChurchesQuery>;
export type CampChurchesLazyQueryHookResult = ReturnType<typeof useCampChurchesLazyQuery>;
export type CampChurchesSuspenseQueryHookResult = ReturnType<typeof useCampChurchesSuspenseQuery>;
export type CampChurchesQueryResult = Apollo.QueryResult<CampChurchesQuery, CampChurchesQueryVariables>;
export const CampChurchesWithStudygroupDocument = gql`
    query campChurchesWithStudygroup($camp_id: Int!) {
  campChurches(camp_id: $camp_id) {
    ...AppCampChurch
    studygroupCollection {
      ...AppStudyGroupCollection
    }
    startStudyGroup {
      id
    }
  }
}
    ${AppCampChurchFragmentDoc}
${AppStudyGroupCollectionFragmentDoc}`;

/**
 * __useCampChurchesWithStudygroupQuery__
 *
 * To run a query within a React component, call `useCampChurchesWithStudygroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampChurchesWithStudygroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampChurchesWithStudygroupQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function useCampChurchesWithStudygroupQuery(baseOptions: Apollo.QueryHookOptions<CampChurchesWithStudygroupQuery, CampChurchesWithStudygroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampChurchesWithStudygroupQuery, CampChurchesWithStudygroupQueryVariables>(CampChurchesWithStudygroupDocument, options);
      }
export function useCampChurchesWithStudygroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampChurchesWithStudygroupQuery, CampChurchesWithStudygroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampChurchesWithStudygroupQuery, CampChurchesWithStudygroupQueryVariables>(CampChurchesWithStudygroupDocument, options);
        }
export function useCampChurchesWithStudygroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampChurchesWithStudygroupQuery, CampChurchesWithStudygroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampChurchesWithStudygroupQuery, CampChurchesWithStudygroupQueryVariables>(CampChurchesWithStudygroupDocument, options);
        }
export type CampChurchesWithStudygroupQueryHookResult = ReturnType<typeof useCampChurchesWithStudygroupQuery>;
export type CampChurchesWithStudygroupLazyQueryHookResult = ReturnType<typeof useCampChurchesWithStudygroupLazyQuery>;
export type CampChurchesWithStudygroupSuspenseQueryHookResult = ReturnType<typeof useCampChurchesWithStudygroupSuspenseQuery>;
export type CampChurchesWithStudygroupQueryResult = Apollo.QueryResult<CampChurchesWithStudygroupQuery, CampChurchesWithStudygroupQueryVariables>;
export const UpdateCampChurchDocument = gql`
    mutation updateCampChurch($input: CampChurchInput!) {
  updateCampChurch(input: $input) {
    ...AppCampChurch
  }
}
    ${AppCampChurchFragmentDoc}`;
export type UpdateCampChurchMutationFn = Apollo.MutationFunction<UpdateCampChurchMutation, UpdateCampChurchMutationVariables>;

/**
 * __useUpdateCampChurchMutation__
 *
 * To run a mutation, you first call `useUpdateCampChurchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampChurchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampChurchMutation, { data, loading, error }] = useUpdateCampChurchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampChurchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampChurchMutation, UpdateCampChurchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampChurchMutation, UpdateCampChurchMutationVariables>(UpdateCampChurchDocument, options);
      }
export type UpdateCampChurchMutationHookResult = ReturnType<typeof useUpdateCampChurchMutation>;
export type UpdateCampChurchMutationResult = Apollo.MutationResult<UpdateCampChurchMutation>;
export type UpdateCampChurchMutationOptions = Apollo.BaseMutationOptions<UpdateCampChurchMutation, UpdateCampChurchMutationVariables>;
export const AddCampChurchDocument = gql`
    mutation addCampChurch($input: CampChurchInput!) {
  addCampChurch(input: $input) {
    ...AppCampChurch
  }
}
    ${AppCampChurchFragmentDoc}`;
export type AddCampChurchMutationFn = Apollo.MutationFunction<AddCampChurchMutation, AddCampChurchMutationVariables>;

/**
 * __useAddCampChurchMutation__
 *
 * To run a mutation, you first call `useAddCampChurchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCampChurchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCampChurchMutation, { data, loading, error }] = useAddCampChurchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCampChurchMutation(baseOptions?: Apollo.MutationHookOptions<AddCampChurchMutation, AddCampChurchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCampChurchMutation, AddCampChurchMutationVariables>(AddCampChurchDocument, options);
      }
export type AddCampChurchMutationHookResult = ReturnType<typeof useAddCampChurchMutation>;
export type AddCampChurchMutationResult = Apollo.MutationResult<AddCampChurchMutation>;
export type AddCampChurchMutationOptions = Apollo.BaseMutationOptions<AddCampChurchMutation, AddCampChurchMutationVariables>;
export const AddCampChurchesDocument = gql`
    mutation addCampChurches($input: [CampChurchInput]!) {
  addCampChurches(input: $input) {
    ...AppCampChurch
  }
}
    ${AppCampChurchFragmentDoc}`;
export type AddCampChurchesMutationFn = Apollo.MutationFunction<AddCampChurchesMutation, AddCampChurchesMutationVariables>;

/**
 * __useAddCampChurchesMutation__
 *
 * To run a mutation, you first call `useAddCampChurchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCampChurchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCampChurchesMutation, { data, loading, error }] = useAddCampChurchesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCampChurchesMutation(baseOptions?: Apollo.MutationHookOptions<AddCampChurchesMutation, AddCampChurchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCampChurchesMutation, AddCampChurchesMutationVariables>(AddCampChurchesDocument, options);
      }
export type AddCampChurchesMutationHookResult = ReturnType<typeof useAddCampChurchesMutation>;
export type AddCampChurchesMutationResult = Apollo.MutationResult<AddCampChurchesMutation>;
export type AddCampChurchesMutationOptions = Apollo.BaseMutationOptions<AddCampChurchesMutation, AddCampChurchesMutationVariables>;
export const DeleteCampChurchDocument = gql`
    mutation deleteCampChurch($id: Int!) {
  deleteCampChurch(id: $id)
}
    `;
export type DeleteCampChurchMutationFn = Apollo.MutationFunction<DeleteCampChurchMutation, DeleteCampChurchMutationVariables>;

/**
 * __useDeleteCampChurchMutation__
 *
 * To run a mutation, you first call `useDeleteCampChurchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampChurchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampChurchMutation, { data, loading, error }] = useDeleteCampChurchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCampChurchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampChurchMutation, DeleteCampChurchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampChurchMutation, DeleteCampChurchMutationVariables>(DeleteCampChurchDocument, options);
      }
export type DeleteCampChurchMutationHookResult = ReturnType<typeof useDeleteCampChurchMutation>;
export type DeleteCampChurchMutationResult = Apollo.MutationResult<DeleteCampChurchMutation>;
export type DeleteCampChurchMutationOptions = Apollo.BaseMutationOptions<DeleteCampChurchMutation, DeleteCampChurchMutationVariables>;
export const MergeChurchWithGroupCollectionDocument = gql`
    mutation mergeChurchWithGroupCollection($id: Int!, $groupCollectionId: Int!) {
  mergeChurchWithGroupCollection(id: $id, groupCollectionId: $groupCollectionId) {
    ...AppCampChurch
  }
}
    ${AppCampChurchFragmentDoc}`;
export type MergeChurchWithGroupCollectionMutationFn = Apollo.MutationFunction<MergeChurchWithGroupCollectionMutation, MergeChurchWithGroupCollectionMutationVariables>;

/**
 * __useMergeChurchWithGroupCollectionMutation__
 *
 * To run a mutation, you first call `useMergeChurchWithGroupCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeChurchWithGroupCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeChurchWithGroupCollectionMutation, { data, loading, error }] = useMergeChurchWithGroupCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      groupCollectionId: // value for 'groupCollectionId'
 *   },
 * });
 */
export function useMergeChurchWithGroupCollectionMutation(baseOptions?: Apollo.MutationHookOptions<MergeChurchWithGroupCollectionMutation, MergeChurchWithGroupCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeChurchWithGroupCollectionMutation, MergeChurchWithGroupCollectionMutationVariables>(MergeChurchWithGroupCollectionDocument, options);
      }
export type MergeChurchWithGroupCollectionMutationHookResult = ReturnType<typeof useMergeChurchWithGroupCollectionMutation>;
export type MergeChurchWithGroupCollectionMutationResult = Apollo.MutationResult<MergeChurchWithGroupCollectionMutation>;
export type MergeChurchWithGroupCollectionMutationOptions = Apollo.BaseMutationOptions<MergeChurchWithGroupCollectionMutation, MergeChurchWithGroupCollectionMutationVariables>;
export const SendHeadleaderEmailDocument = gql`
    mutation sendHeadleaderEmail($id: Int!) {
  sendHeadleaderEmail(id: $id)
}
    `;
export type SendHeadleaderEmailMutationFn = Apollo.MutationFunction<SendHeadleaderEmailMutation, SendHeadleaderEmailMutationVariables>;

/**
 * __useSendHeadleaderEmailMutation__
 *
 * To run a mutation, you first call `useSendHeadleaderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendHeadleaderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendHeadleaderEmailMutation, { data, loading, error }] = useSendHeadleaderEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendHeadleaderEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendHeadleaderEmailMutation, SendHeadleaderEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendHeadleaderEmailMutation, SendHeadleaderEmailMutationVariables>(SendHeadleaderEmailDocument, options);
      }
export type SendHeadleaderEmailMutationHookResult = ReturnType<typeof useSendHeadleaderEmailMutation>;
export type SendHeadleaderEmailMutationResult = Apollo.MutationResult<SendHeadleaderEmailMutation>;
export type SendHeadleaderEmailMutationOptions = Apollo.BaseMutationOptions<SendHeadleaderEmailMutation, SendHeadleaderEmailMutationVariables>;
export const RegenerateHeadLeaderLinkDocument = gql`
    mutation regenerateHeadLeaderLink($id: Int!) {
  regenerateHeadLeaderLink(id: $id) {
    ...AppCampChurch
  }
}
    ${AppCampChurchFragmentDoc}`;
export type RegenerateHeadLeaderLinkMutationFn = Apollo.MutationFunction<RegenerateHeadLeaderLinkMutation, RegenerateHeadLeaderLinkMutationVariables>;

/**
 * __useRegenerateHeadLeaderLinkMutation__
 *
 * To run a mutation, you first call `useRegenerateHeadLeaderLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateHeadLeaderLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateHeadLeaderLinkMutation, { data, loading, error }] = useRegenerateHeadLeaderLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegenerateHeadLeaderLinkMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateHeadLeaderLinkMutation, RegenerateHeadLeaderLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateHeadLeaderLinkMutation, RegenerateHeadLeaderLinkMutationVariables>(RegenerateHeadLeaderLinkDocument, options);
      }
export type RegenerateHeadLeaderLinkMutationHookResult = ReturnType<typeof useRegenerateHeadLeaderLinkMutation>;
export type RegenerateHeadLeaderLinkMutationResult = Apollo.MutationResult<RegenerateHeadLeaderLinkMutation>;
export type RegenerateHeadLeaderLinkMutationOptions = Apollo.BaseMutationOptions<RegenerateHeadLeaderLinkMutation, RegenerateHeadLeaderLinkMutationVariables>;
export const RegenerateLeaderLinkDocument = gql`
    mutation regenerateLeaderLink($id: Int!) {
  regenerateLeaderLink(id: $id) {
    ...AppCampChurch
  }
}
    ${AppCampChurchFragmentDoc}`;
export type RegenerateLeaderLinkMutationFn = Apollo.MutationFunction<RegenerateLeaderLinkMutation, RegenerateLeaderLinkMutationVariables>;

/**
 * __useRegenerateLeaderLinkMutation__
 *
 * To run a mutation, you first call `useRegenerateLeaderLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateLeaderLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateLeaderLinkMutation, { data, loading, error }] = useRegenerateLeaderLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegenerateLeaderLinkMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateLeaderLinkMutation, RegenerateLeaderLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateLeaderLinkMutation, RegenerateLeaderLinkMutationVariables>(RegenerateLeaderLinkDocument, options);
      }
export type RegenerateLeaderLinkMutationHookResult = ReturnType<typeof useRegenerateLeaderLinkMutation>;
export type RegenerateLeaderLinkMutationResult = Apollo.MutationResult<RegenerateLeaderLinkMutation>;
export type RegenerateLeaderLinkMutationOptions = Apollo.BaseMutationOptions<RegenerateLeaderLinkMutation, RegenerateLeaderLinkMutationVariables>;
export const SeparateChurchFromGroupCollectionDocument = gql`
    mutation separateChurchFromGroupCollection($id: Int!) {
  separateChurchFromGroupCollection(id: $id) {
    ...AppCampChurch
  }
}
    ${AppCampChurchFragmentDoc}`;
export type SeparateChurchFromGroupCollectionMutationFn = Apollo.MutationFunction<SeparateChurchFromGroupCollectionMutation, SeparateChurchFromGroupCollectionMutationVariables>;

/**
 * __useSeparateChurchFromGroupCollectionMutation__
 *
 * To run a mutation, you first call `useSeparateChurchFromGroupCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeparateChurchFromGroupCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [separateChurchFromGroupCollectionMutation, { data, loading, error }] = useSeparateChurchFromGroupCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSeparateChurchFromGroupCollectionMutation(baseOptions?: Apollo.MutationHookOptions<SeparateChurchFromGroupCollectionMutation, SeparateChurchFromGroupCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SeparateChurchFromGroupCollectionMutation, SeparateChurchFromGroupCollectionMutationVariables>(SeparateChurchFromGroupCollectionDocument, options);
      }
export type SeparateChurchFromGroupCollectionMutationHookResult = ReturnType<typeof useSeparateChurchFromGroupCollectionMutation>;
export type SeparateChurchFromGroupCollectionMutationResult = Apollo.MutationResult<SeparateChurchFromGroupCollectionMutation>;
export type SeparateChurchFromGroupCollectionMutationOptions = Apollo.BaseMutationOptions<SeparateChurchFromGroupCollectionMutation, SeparateChurchFromGroupCollectionMutationVariables>;
export const AdminChurchLinkDocument = gql`
    query adminChurchLink($link: String!, $password: String) {
  adminChurchLink(link: $link, password: $password) {
    ...AppChurchLink
    persons {
      ...AppPerson
      ...PersonCampCollections
    }
    camp {
      camp_id
      name
      start_date
      end_date
      studygroups_active
      campCollections
      panicMode
      panicModeText
    }
  }
}
    ${AppChurchLinkFragmentDoc}
${AppPersonFragmentDoc}
${PersonCampCollectionsFragmentDoc}`;

/**
 * __useAdminChurchLinkQuery__
 *
 * To run a query within a React component, call `useAdminChurchLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminChurchLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminChurchLinkQuery({
 *   variables: {
 *      link: // value for 'link'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAdminChurchLinkQuery(baseOptions: Apollo.QueryHookOptions<AdminChurchLinkQuery, AdminChurchLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminChurchLinkQuery, AdminChurchLinkQueryVariables>(AdminChurchLinkDocument, options);
      }
export function useAdminChurchLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminChurchLinkQuery, AdminChurchLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminChurchLinkQuery, AdminChurchLinkQueryVariables>(AdminChurchLinkDocument, options);
        }
export function useAdminChurchLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminChurchLinkQuery, AdminChurchLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminChurchLinkQuery, AdminChurchLinkQueryVariables>(AdminChurchLinkDocument, options);
        }
export type AdminChurchLinkQueryHookResult = ReturnType<typeof useAdminChurchLinkQuery>;
export type AdminChurchLinkLazyQueryHookResult = ReturnType<typeof useAdminChurchLinkLazyQuery>;
export type AdminChurchLinkSuspenseQueryHookResult = ReturnType<typeof useAdminChurchLinkSuspenseQuery>;
export type AdminChurchLinkQueryResult = Apollo.QueryResult<AdminChurchLinkQuery, AdminChurchLinkQueryVariables>;
export const LeaderChurchLinkDocument = gql`
    query leaderChurchLink($link: String!, $password: String) {
  leaderChurchLink(link: $link, password: $password) {
    ...AppChurchLink
    persons {
      ...AppPerson
      ...PersonCampCollections
    }
    camp {
      camp_id
      name
      start_date
      end_date
      studygroups_active
      campCollections
      panicMode
      panicModeText
    }
  }
}
    ${AppChurchLinkFragmentDoc}
${AppPersonFragmentDoc}
${PersonCampCollectionsFragmentDoc}`;

/**
 * __useLeaderChurchLinkQuery__
 *
 * To run a query within a React component, call `useLeaderChurchLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderChurchLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderChurchLinkQuery({
 *   variables: {
 *      link: // value for 'link'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLeaderChurchLinkQuery(baseOptions: Apollo.QueryHookOptions<LeaderChurchLinkQuery, LeaderChurchLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaderChurchLinkQuery, LeaderChurchLinkQueryVariables>(LeaderChurchLinkDocument, options);
      }
export function useLeaderChurchLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaderChurchLinkQuery, LeaderChurchLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaderChurchLinkQuery, LeaderChurchLinkQueryVariables>(LeaderChurchLinkDocument, options);
        }
export function useLeaderChurchLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LeaderChurchLinkQuery, LeaderChurchLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeaderChurchLinkQuery, LeaderChurchLinkQueryVariables>(LeaderChurchLinkDocument, options);
        }
export type LeaderChurchLinkQueryHookResult = ReturnType<typeof useLeaderChurchLinkQuery>;
export type LeaderChurchLinkLazyQueryHookResult = ReturnType<typeof useLeaderChurchLinkLazyQuery>;
export type LeaderChurchLinkSuspenseQueryHookResult = ReturnType<typeof useLeaderChurchLinkSuspenseQuery>;
export type LeaderChurchLinkQueryResult = Apollo.QueryResult<LeaderChurchLinkQuery, LeaderChurchLinkQueryVariables>;
export const StudygroupCollectionDocument = gql`
    query studygroupCollection($id: Int!) {
  studygroupCollection(id: $id) {
    ...AppStudyGroupCollection
  }
}
    ${AppStudyGroupCollectionFragmentDoc}`;

/**
 * __useStudygroupCollectionQuery__
 *
 * To run a query within a React component, call `useStudygroupCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudygroupCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudygroupCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudygroupCollectionQuery(baseOptions: Apollo.QueryHookOptions<StudygroupCollectionQuery, StudygroupCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudygroupCollectionQuery, StudygroupCollectionQueryVariables>(StudygroupCollectionDocument, options);
      }
export function useStudygroupCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudygroupCollectionQuery, StudygroupCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudygroupCollectionQuery, StudygroupCollectionQueryVariables>(StudygroupCollectionDocument, options);
        }
export function useStudygroupCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StudygroupCollectionQuery, StudygroupCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudygroupCollectionQuery, StudygroupCollectionQueryVariables>(StudygroupCollectionDocument, options);
        }
export type StudygroupCollectionQueryHookResult = ReturnType<typeof useStudygroupCollectionQuery>;
export type StudygroupCollectionLazyQueryHookResult = ReturnType<typeof useStudygroupCollectionLazyQuery>;
export type StudygroupCollectionSuspenseQueryHookResult = ReturnType<typeof useStudygroupCollectionSuspenseQuery>;
export type StudygroupCollectionQueryResult = Apollo.QueryResult<StudygroupCollectionQuery, StudygroupCollectionQueryVariables>;
export const DeleteStudygroupDocument = gql`
    mutation deleteStudygroup($id: Int!) {
  deleteStudygroup(id: $id)
}
    `;
export type DeleteStudygroupMutationFn = Apollo.MutationFunction<DeleteStudygroupMutation, DeleteStudygroupMutationVariables>;

/**
 * __useDeleteStudygroupMutation__
 *
 * To run a mutation, you first call `useDeleteStudygroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudygroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudygroupMutation, { data, loading, error }] = useDeleteStudygroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStudygroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudygroupMutation, DeleteStudygroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStudygroupMutation, DeleteStudygroupMutationVariables>(DeleteStudygroupDocument, options);
      }
export type DeleteStudygroupMutationHookResult = ReturnType<typeof useDeleteStudygroupMutation>;
export type DeleteStudygroupMutationResult = Apollo.MutationResult<DeleteStudygroupMutation>;
export type DeleteStudygroupMutationOptions = Apollo.BaseMutationOptions<DeleteStudygroupMutation, DeleteStudygroupMutationVariables>;
export const CreateStudygroupDocument = gql`
    mutation createStudygroup($groupCollectionId: Int!, $name: String) {
  createStudygroup(groupCollectionId: $groupCollectionId, name: $name) {
    ...AppStudyGroup
  }
}
    ${AppStudyGroupFragmentDoc}`;
export type CreateStudygroupMutationFn = Apollo.MutationFunction<CreateStudygroupMutation, CreateStudygroupMutationVariables>;

/**
 * __useCreateStudygroupMutation__
 *
 * To run a mutation, you first call `useCreateStudygroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudygroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudygroupMutation, { data, loading, error }] = useCreateStudygroupMutation({
 *   variables: {
 *      groupCollectionId: // value for 'groupCollectionId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateStudygroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateStudygroupMutation, CreateStudygroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStudygroupMutation, CreateStudygroupMutationVariables>(CreateStudygroupDocument, options);
      }
export type CreateStudygroupMutationHookResult = ReturnType<typeof useCreateStudygroupMutation>;
export type CreateStudygroupMutationResult = Apollo.MutationResult<CreateStudygroupMutation>;
export type CreateStudygroupMutationOptions = Apollo.BaseMutationOptions<CreateStudygroupMutation, CreateStudygroupMutationVariables>;
export const UpdateStudygroupDocument = gql`
    mutation updateStudygroup($id: Int!, $name: String) {
  updateStudygroup(id: $id, name: $name) {
    ...AppStudyGroup
  }
}
    ${AppStudyGroupFragmentDoc}`;
export type UpdateStudygroupMutationFn = Apollo.MutationFunction<UpdateStudygroupMutation, UpdateStudygroupMutationVariables>;

/**
 * __useUpdateStudygroupMutation__
 *
 * To run a mutation, you first call `useUpdateStudygroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudygroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudygroupMutation, { data, loading, error }] = useUpdateStudygroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateStudygroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudygroupMutation, UpdateStudygroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudygroupMutation, UpdateStudygroupMutationVariables>(UpdateStudygroupDocument, options);
      }
export type UpdateStudygroupMutationHookResult = ReturnType<typeof useUpdateStudygroupMutation>;
export type UpdateStudygroupMutationResult = Apollo.MutationResult<UpdateStudygroupMutation>;
export type UpdateStudygroupMutationOptions = Apollo.BaseMutationOptions<UpdateStudygroupMutation, UpdateStudygroupMutationVariables>;
export const StudygroupStatisticsDocument = gql`
    query studygroupStatistics($camp_id: Int!) {
  studygroupStatistics(camp_id: $camp_id) {
    studygroupCount
    studygroupsFromPersonsInStartgroups {
      ...AppStudyGroup
    }
  }
}
    ${AppStudyGroupFragmentDoc}`;

/**
 * __useStudygroupStatisticsQuery__
 *
 * To run a query within a React component, call `useStudygroupStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudygroupStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudygroupStatisticsQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function useStudygroupStatisticsQuery(baseOptions: Apollo.QueryHookOptions<StudygroupStatisticsQuery, StudygroupStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudygroupStatisticsQuery, StudygroupStatisticsQueryVariables>(StudygroupStatisticsDocument, options);
      }
export function useStudygroupStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudygroupStatisticsQuery, StudygroupStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudygroupStatisticsQuery, StudygroupStatisticsQueryVariables>(StudygroupStatisticsDocument, options);
        }
export function useStudygroupStatisticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StudygroupStatisticsQuery, StudygroupStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudygroupStatisticsQuery, StudygroupStatisticsQueryVariables>(StudygroupStatisticsDocument, options);
        }
export type StudygroupStatisticsQueryHookResult = ReturnType<typeof useStudygroupStatisticsQuery>;
export type StudygroupStatisticsLazyQueryHookResult = ReturnType<typeof useStudygroupStatisticsLazyQuery>;
export type StudygroupStatisticsSuspenseQueryHookResult = ReturnType<typeof useStudygroupStatisticsSuspenseQuery>;
export type StudygroupStatisticsQueryResult = Apollo.QueryResult<StudygroupStatisticsQuery, StudygroupStatisticsQueryVariables>;
export const MediaLibraryDocument = gql`
    query MediaLibrary {
  mediaLibrary {
    ...AppMedia
  }
}
    ${AppMediaFragmentDoc}`;

/**
 * __useMediaLibraryQuery__
 *
 * To run a query within a React component, call `useMediaLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaLibraryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMediaLibraryQuery(baseOptions?: Apollo.QueryHookOptions<MediaLibraryQuery, MediaLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaLibraryQuery, MediaLibraryQueryVariables>(MediaLibraryDocument, options);
      }
export function useMediaLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaLibraryQuery, MediaLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaLibraryQuery, MediaLibraryQueryVariables>(MediaLibraryDocument, options);
        }
export function useMediaLibrarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaLibraryQuery, MediaLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaLibraryQuery, MediaLibraryQueryVariables>(MediaLibraryDocument, options);
        }
export type MediaLibraryQueryHookResult = ReturnType<typeof useMediaLibraryQuery>;
export type MediaLibraryLazyQueryHookResult = ReturnType<typeof useMediaLibraryLazyQuery>;
export type MediaLibrarySuspenseQueryHookResult = ReturnType<typeof useMediaLibrarySuspenseQuery>;
export type MediaLibraryQueryResult = Apollo.QueryResult<MediaLibraryQuery, MediaLibraryQueryVariables>;
export const DeleteMediaDocument = gql`
    mutation DeleteMedia($id: Int!) {
  deleteMedia(id: $id)
}
    `;
export type DeleteMediaMutationFn = Apollo.MutationFunction<DeleteMediaMutation, DeleteMediaMutationVariables>;

/**
 * __useDeleteMediaMutation__
 *
 * To run a mutation, you first call `useDeleteMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaMutation, { data, loading, error }] = useDeleteMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMediaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMediaMutation, DeleteMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMediaMutation, DeleteMediaMutationVariables>(DeleteMediaDocument, options);
      }
export type DeleteMediaMutationHookResult = ReturnType<typeof useDeleteMediaMutation>;
export type DeleteMediaMutationResult = Apollo.MutationResult<DeleteMediaMutation>;
export type DeleteMediaMutationOptions = Apollo.BaseMutationOptions<DeleteMediaMutation, DeleteMediaMutationVariables>;
export const PaymentsDocument = gql`
    query Payments($camp_id: Int!) {
  payments(camp_id: $camp_id) {
    ...AppPayment
  }
}
    ${AppPaymentFragmentDoc}`;

/**
 * __usePaymentsQuery__
 *
 * To run a query within a React component, call `usePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function usePaymentsQuery(baseOptions: Apollo.QueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
      }
export function usePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
        }
export function usePaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
        }
export type PaymentsQueryHookResult = ReturnType<typeof usePaymentsQuery>;
export type PaymentsLazyQueryHookResult = ReturnType<typeof usePaymentsLazyQuery>;
export type PaymentsSuspenseQueryHookResult = ReturnType<typeof usePaymentsSuspenseQuery>;
export type PaymentsQueryResult = Apollo.QueryResult<PaymentsQuery, PaymentsQueryVariables>;
export const CheckPaymentDocument = gql`
    mutation checkPayment($id: Int!) {
  checkPayment(paymentId: $id) {
    ...AppPayment
  }
}
    ${AppPaymentFragmentDoc}`;
export type CheckPaymentMutationFn = Apollo.MutationFunction<CheckPaymentMutation, CheckPaymentMutationVariables>;

/**
 * __useCheckPaymentMutation__
 *
 * To run a mutation, you first call `useCheckPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkPaymentMutation, { data, loading, error }] = useCheckPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CheckPaymentMutation, CheckPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckPaymentMutation, CheckPaymentMutationVariables>(CheckPaymentDocument, options);
      }
export type CheckPaymentMutationHookResult = ReturnType<typeof useCheckPaymentMutation>;
export type CheckPaymentMutationResult = Apollo.MutationResult<CheckPaymentMutation>;
export type CheckPaymentMutationOptions = Apollo.BaseMutationOptions<CheckPaymentMutation, CheckPaymentMutationVariables>;
export const RefundPaymentDocument = gql`
    mutation refundPayment($id: Int!, $amount: Int!, $reason: String!) {
  refundPayment(paymentId: $id, amount: $amount, reason: $reason) {
    ...AppPayment
  }
}
    ${AppPaymentFragmentDoc}`;
export type RefundPaymentMutationFn = Apollo.MutationFunction<RefundPaymentMutation, RefundPaymentMutationVariables>;

/**
 * __useRefundPaymentMutation__
 *
 * To run a mutation, you first call `useRefundPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundPaymentMutation, { data, loading, error }] = useRefundPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      amount: // value for 'amount'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRefundPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RefundPaymentMutation, RefundPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundPaymentMutation, RefundPaymentMutationVariables>(RefundPaymentDocument, options);
      }
export type RefundPaymentMutationHookResult = ReturnType<typeof useRefundPaymentMutation>;
export type RefundPaymentMutationResult = Apollo.MutationResult<RefundPaymentMutation>;
export type RefundPaymentMutationOptions = Apollo.BaseMutationOptions<RefundPaymentMutation, RefundPaymentMutationVariables>;
export const PersonsStatisticsDocument = gql`
    query personsStatistics($camp_id: Int!) {
  personsStatistics(camp_id: $camp_id) {
    total
    week
    today
  }
}
    `;

/**
 * __usePersonsStatisticsQuery__
 *
 * To run a query within a React component, call `usePersonsStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonsStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonsStatisticsQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function usePersonsStatisticsQuery(baseOptions: Apollo.QueryHookOptions<PersonsStatisticsQuery, PersonsStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonsStatisticsQuery, PersonsStatisticsQueryVariables>(PersonsStatisticsDocument, options);
      }
export function usePersonsStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonsStatisticsQuery, PersonsStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonsStatisticsQuery, PersonsStatisticsQueryVariables>(PersonsStatisticsDocument, options);
        }
export function usePersonsStatisticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonsStatisticsQuery, PersonsStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonsStatisticsQuery, PersonsStatisticsQueryVariables>(PersonsStatisticsDocument, options);
        }
export type PersonsStatisticsQueryHookResult = ReturnType<typeof usePersonsStatisticsQuery>;
export type PersonsStatisticsLazyQueryHookResult = ReturnType<typeof usePersonsStatisticsLazyQuery>;
export type PersonsStatisticsSuspenseQueryHookResult = ReturnType<typeof usePersonsStatisticsSuspenseQuery>;
export type PersonsStatisticsQueryResult = Apollo.QueryResult<PersonsStatisticsQuery, PersonsStatisticsQueryVariables>;
export const PersonsDocument = gql`
    query Persons($camp_id: Int!) {
  campColumns(camp_id: $camp_id) {
    ...AppCampColumn
  }
  persons(camp_id: $camp_id) {
    ...AppPerson
    ...PersonCampCollections
  }
  campCollections(camp_id: $camp_id)
}
    ${AppCampColumnFragmentDoc}
${AppPersonFragmentDoc}
${PersonCampCollectionsFragmentDoc}`;

/**
 * __usePersonsQuery__
 *
 * To run a query within a React component, call `usePersonsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonsQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function usePersonsQuery(baseOptions: Apollo.QueryHookOptions<PersonsQuery, PersonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonsQuery, PersonsQueryVariables>(PersonsDocument, options);
      }
export function usePersonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonsQuery, PersonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonsQuery, PersonsQueryVariables>(PersonsDocument, options);
        }
export function usePersonsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonsQuery, PersonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonsQuery, PersonsQueryVariables>(PersonsDocument, options);
        }
export type PersonsQueryHookResult = ReturnType<typeof usePersonsQuery>;
export type PersonsLazyQueryHookResult = ReturnType<typeof usePersonsLazyQuery>;
export type PersonsSuspenseQueryHookResult = ReturnType<typeof usePersonsSuspenseQuery>;
export type PersonsQueryResult = Apollo.QueryResult<PersonsQuery, PersonsQueryVariables>;
export const UpdatePersonDocument = gql`
    mutation updatePerson($id: Int!, $values: JSONObject!) {
  updatePerson(id: $id, values: $values) {
    ...AppPerson
    ...PersonCampCollections
  }
}
    ${AppPersonFragmentDoc}
${PersonCampCollectionsFragmentDoc}`;
export type UpdatePersonMutationFn = Apollo.MutationFunction<UpdatePersonMutation, UpdatePersonMutationVariables>;

/**
 * __useUpdatePersonMutation__
 *
 * To run a mutation, you first call `useUpdatePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonMutation, { data, loading, error }] = useUpdatePersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdatePersonMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonMutation, UpdatePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonMutation, UpdatePersonMutationVariables>(UpdatePersonDocument, options);
      }
export type UpdatePersonMutationHookResult = ReturnType<typeof useUpdatePersonMutation>;
export type UpdatePersonMutationResult = Apollo.MutationResult<UpdatePersonMutation>;
export type UpdatePersonMutationOptions = Apollo.BaseMutationOptions<UpdatePersonMutation, UpdatePersonMutationVariables>;
export const UpdatePersonStudygroupDocument = gql`
    mutation updatePersonStudygroup($id: Int!, $studygroupId: Int!) {
  updatePersonStudygroup(id: $id, studygroupId: $studygroupId) {
    ...AppPerson
    ...PersonCampCollections
  }
}
    ${AppPersonFragmentDoc}
${PersonCampCollectionsFragmentDoc}`;
export type UpdatePersonStudygroupMutationFn = Apollo.MutationFunction<UpdatePersonStudygroupMutation, UpdatePersonStudygroupMutationVariables>;

/**
 * __useUpdatePersonStudygroupMutation__
 *
 * To run a mutation, you first call `useUpdatePersonStudygroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonStudygroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonStudygroupMutation, { data, loading, error }] = useUpdatePersonStudygroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      studygroupId: // value for 'studygroupId'
 *   },
 * });
 */
export function useUpdatePersonStudygroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonStudygroupMutation, UpdatePersonStudygroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonStudygroupMutation, UpdatePersonStudygroupMutationVariables>(UpdatePersonStudygroupDocument, options);
      }
export type UpdatePersonStudygroupMutationHookResult = ReturnType<typeof useUpdatePersonStudygroupMutation>;
export type UpdatePersonStudygroupMutationResult = Apollo.MutationResult<UpdatePersonStudygroupMutation>;
export type UpdatePersonStudygroupMutationOptions = Apollo.BaseMutationOptions<UpdatePersonStudygroupMutation, UpdatePersonStudygroupMutationVariables>;
export const PersonMutatedDocument = gql`
    subscription personMutated($camp_id: Int!) {
  personMutated(camp_id: $camp_id) {
    mutation
    node {
      ...AppPerson
      ...PersonCampCollections
    }
  }
}
    ${AppPersonFragmentDoc}
${PersonCampCollectionsFragmentDoc}`;

/**
 * __usePersonMutatedSubscription__
 *
 * To run a query within a React component, call `usePersonMutatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePersonMutatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonMutatedSubscription({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function usePersonMutatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<PersonMutatedSubscription, PersonMutatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PersonMutatedSubscription, PersonMutatedSubscriptionVariables>(PersonMutatedDocument, options);
      }
export type PersonMutatedSubscriptionHookResult = ReturnType<typeof usePersonMutatedSubscription>;
export type PersonMutatedSubscriptionResult = Apollo.SubscriptionResult<PersonMutatedSubscription>;
export const CampMainConductorsDocument = gql`
    query campMainConductors($camp_id: Int!) {
  campMainConductors(camp_id: $camp_id) {
    ...AppPerson
  }
}
    ${AppPersonFragmentDoc}`;

/**
 * __useCampMainConductorsQuery__
 *
 * To run a query within a React component, call `useCampMainConductorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampMainConductorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampMainConductorsQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function useCampMainConductorsQuery(baseOptions: Apollo.QueryHookOptions<CampMainConductorsQuery, CampMainConductorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampMainConductorsQuery, CampMainConductorsQueryVariables>(CampMainConductorsDocument, options);
      }
export function useCampMainConductorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampMainConductorsQuery, CampMainConductorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampMainConductorsQuery, CampMainConductorsQueryVariables>(CampMainConductorsDocument, options);
        }
export function useCampMainConductorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampMainConductorsQuery, CampMainConductorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampMainConductorsQuery, CampMainConductorsQueryVariables>(CampMainConductorsDocument, options);
        }
export type CampMainConductorsQueryHookResult = ReturnType<typeof useCampMainConductorsQuery>;
export type CampMainConductorsLazyQueryHookResult = ReturnType<typeof useCampMainConductorsLazyQuery>;
export type CampMainConductorsSuspenseQueryHookResult = ReturnType<typeof useCampMainConductorsSuspenseQuery>;
export type CampMainConductorsQueryResult = Apollo.QueryResult<CampMainConductorsQuery, CampMainConductorsQueryVariables>;
export const GenerateReportDocument = gql`
    mutation generateReport($campIds: [Int]!, $password: String!) {
  generateReport(campIds: $campIds, password: $password)
}
    `;
export type GenerateReportMutationFn = Apollo.MutationFunction<GenerateReportMutation, GenerateReportMutationVariables>;

/**
 * __useGenerateReportMutation__
 *
 * To run a mutation, you first call `useGenerateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportMutation, { data, loading, error }] = useGenerateReportMutation({
 *   variables: {
 *      campIds: // value for 'campIds'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGenerateReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReportMutation, GenerateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReportMutation, GenerateReportMutationVariables>(GenerateReportDocument, options);
      }
export type GenerateReportMutationHookResult = ReturnType<typeof useGenerateReportMutation>;
export type GenerateReportMutationResult = Apollo.MutationResult<GenerateReportMutation>;
export type GenerateReportMutationOptions = Apollo.BaseMutationOptions<GenerateReportMutation, GenerateReportMutationVariables>;
export const CreateOneTimeCodeDocument = gql`
    mutation createOneTimeCode {
  createOneTimeCode
}
    `;
export type CreateOneTimeCodeMutationFn = Apollo.MutationFunction<CreateOneTimeCodeMutation, CreateOneTimeCodeMutationVariables>;

/**
 * __useCreateOneTimeCodeMutation__
 *
 * To run a mutation, you first call `useCreateOneTimeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneTimeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneTimeCodeMutation, { data, loading, error }] = useCreateOneTimeCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateOneTimeCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneTimeCodeMutation, CreateOneTimeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneTimeCodeMutation, CreateOneTimeCodeMutationVariables>(CreateOneTimeCodeDocument, options);
      }
export type CreateOneTimeCodeMutationHookResult = ReturnType<typeof useCreateOneTimeCodeMutation>;
export type CreateOneTimeCodeMutationResult = Apollo.MutationResult<CreateOneTimeCodeMutation>;
export type CreateOneTimeCodeMutationOptions = Apollo.BaseMutationOptions<CreateOneTimeCodeMutation, CreateOneTimeCodeMutationVariables>;
export const NewsPostsDocument = gql`
    query NewsPosts($card_id: Int!) {
  newsPosts(card_id: $card_id) {
    ...AppNewsPost
  }
}
    ${AppNewsPostFragmentDoc}`;

/**
 * __useNewsPostsQuery__
 *
 * To run a query within a React component, call `useNewsPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsPostsQuery({
 *   variables: {
 *      card_id: // value for 'card_id'
 *   },
 * });
 */
export function useNewsPostsQuery(baseOptions: Apollo.QueryHookOptions<NewsPostsQuery, NewsPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsPostsQuery, NewsPostsQueryVariables>(NewsPostsDocument, options);
      }
export function useNewsPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsPostsQuery, NewsPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsPostsQuery, NewsPostsQueryVariables>(NewsPostsDocument, options);
        }
export function useNewsPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewsPostsQuery, NewsPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsPostsQuery, NewsPostsQueryVariables>(NewsPostsDocument, options);
        }
export type NewsPostsQueryHookResult = ReturnType<typeof useNewsPostsQuery>;
export type NewsPostsLazyQueryHookResult = ReturnType<typeof useNewsPostsLazyQuery>;
export type NewsPostsSuspenseQueryHookResult = ReturnType<typeof useNewsPostsSuspenseQuery>;
export type NewsPostsQueryResult = Apollo.QueryResult<NewsPostsQuery, NewsPostsQueryVariables>;
export const CreateNewsPostDocument = gql`
    mutation CreateNewsPost($body: NewsPostInput!) {
  createNewsPost(body: $body) {
    ...AppNewsPost
  }
}
    ${AppNewsPostFragmentDoc}`;
export type CreateNewsPostMutationFn = Apollo.MutationFunction<CreateNewsPostMutation, CreateNewsPostMutationVariables>;

/**
 * __useCreateNewsPostMutation__
 *
 * To run a mutation, you first call `useCreateNewsPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsPostMutation, { data, loading, error }] = useCreateNewsPostMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateNewsPostMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewsPostMutation, CreateNewsPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewsPostMutation, CreateNewsPostMutationVariables>(CreateNewsPostDocument, options);
      }
export type CreateNewsPostMutationHookResult = ReturnType<typeof useCreateNewsPostMutation>;
export type CreateNewsPostMutationResult = Apollo.MutationResult<CreateNewsPostMutation>;
export type CreateNewsPostMutationOptions = Apollo.BaseMutationOptions<CreateNewsPostMutation, CreateNewsPostMutationVariables>;
export const UpdateNewsPostDocument = gql`
    mutation UpdateNewsPost($body: NewsPostUpdate!) {
  updateNewsPost(body: $body) {
    ...AppNewsPost
  }
}
    ${AppNewsPostFragmentDoc}`;
export type UpdateNewsPostMutationFn = Apollo.MutationFunction<UpdateNewsPostMutation, UpdateNewsPostMutationVariables>;

/**
 * __useUpdateNewsPostMutation__
 *
 * To run a mutation, you first call `useUpdateNewsPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsPostMutation, { data, loading, error }] = useUpdateNewsPostMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateNewsPostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewsPostMutation, UpdateNewsPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewsPostMutation, UpdateNewsPostMutationVariables>(UpdateNewsPostDocument, options);
      }
export type UpdateNewsPostMutationHookResult = ReturnType<typeof useUpdateNewsPostMutation>;
export type UpdateNewsPostMutationResult = Apollo.MutationResult<UpdateNewsPostMutation>;
export type UpdateNewsPostMutationOptions = Apollo.BaseMutationOptions<UpdateNewsPostMutation, UpdateNewsPostMutationVariables>;
export const DeleteNewsPostDocument = gql`
    mutation deleteNewsPost($newsPostId: Int!) {
  deleteNewsPost(id: $newsPostId)
}
    `;
export type DeleteNewsPostMutationFn = Apollo.MutationFunction<DeleteNewsPostMutation, DeleteNewsPostMutationVariables>;

/**
 * __useDeleteNewsPostMutation__
 *
 * To run a mutation, you first call `useDeleteNewsPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNewsPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNewsPostMutation, { data, loading, error }] = useDeleteNewsPostMutation({
 *   variables: {
 *      newsPostId: // value for 'newsPostId'
 *   },
 * });
 */
export function useDeleteNewsPostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNewsPostMutation, DeleteNewsPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNewsPostMutation, DeleteNewsPostMutationVariables>(DeleteNewsPostDocument, options);
      }
export type DeleteNewsPostMutationHookResult = ReturnType<typeof useDeleteNewsPostMutation>;
export type DeleteNewsPostMutationResult = Apollo.MutationResult<DeleteNewsPostMutation>;
export type DeleteNewsPostMutationOptions = Apollo.BaseMutationOptions<DeleteNewsPostMutation, DeleteNewsPostMutationVariables>;
export const PushNotificationsDocument = gql`
    query PushNotifications($camp_id: Int!) {
  pushNotifications(camp_id: $camp_id) {
    ...AppPushNotification
  }
}
    ${AppPushNotificationFragmentDoc}`;

/**
 * __usePushNotificationsQuery__
 *
 * To run a query within a React component, call `usePushNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePushNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushNotificationsQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *   },
 * });
 */
export function usePushNotificationsQuery(baseOptions: Apollo.QueryHookOptions<PushNotificationsQuery, PushNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PushNotificationsQuery, PushNotificationsQueryVariables>(PushNotificationsDocument, options);
      }
export function usePushNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PushNotificationsQuery, PushNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PushNotificationsQuery, PushNotificationsQueryVariables>(PushNotificationsDocument, options);
        }
export function usePushNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PushNotificationsQuery, PushNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PushNotificationsQuery, PushNotificationsQueryVariables>(PushNotificationsDocument, options);
        }
export type PushNotificationsQueryHookResult = ReturnType<typeof usePushNotificationsQuery>;
export type PushNotificationsLazyQueryHookResult = ReturnType<typeof usePushNotificationsLazyQuery>;
export type PushNotificationsSuspenseQueryHookResult = ReturnType<typeof usePushNotificationsSuspenseQuery>;
export type PushNotificationsQueryResult = Apollo.QueryResult<PushNotificationsQuery, PushNotificationsQueryVariables>;
export const DeletePushNotificationDocument = gql`
    mutation deletePushNotification($pushNotificationId: Int!) {
  deletePushNotification(id: $pushNotificationId)
}
    `;
export type DeletePushNotificationMutationFn = Apollo.MutationFunction<DeletePushNotificationMutation, DeletePushNotificationMutationVariables>;

/**
 * __useDeletePushNotificationMutation__
 *
 * To run a mutation, you first call `useDeletePushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePushNotificationMutation, { data, loading, error }] = useDeletePushNotificationMutation({
 *   variables: {
 *      pushNotificationId: // value for 'pushNotificationId'
 *   },
 * });
 */
export function useDeletePushNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeletePushNotificationMutation, DeletePushNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePushNotificationMutation, DeletePushNotificationMutationVariables>(DeletePushNotificationDocument, options);
      }
export type DeletePushNotificationMutationHookResult = ReturnType<typeof useDeletePushNotificationMutation>;
export type DeletePushNotificationMutationResult = Apollo.MutationResult<DeletePushNotificationMutation>;
export type DeletePushNotificationMutationOptions = Apollo.BaseMutationOptions<DeletePushNotificationMutation, DeletePushNotificationMutationVariables>;
export const UpdatePushNotificationDocument = gql`
    mutation updatePushNotification($body: PushNotificationUpdate!) {
  updatePushNotification(body: $body) {
    ...AppPushNotification
  }
}
    ${AppPushNotificationFragmentDoc}`;
export type UpdatePushNotificationMutationFn = Apollo.MutationFunction<UpdatePushNotificationMutation, UpdatePushNotificationMutationVariables>;

/**
 * __useUpdatePushNotificationMutation__
 *
 * To run a mutation, you first call `useUpdatePushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePushNotificationMutation, { data, loading, error }] = useUpdatePushNotificationMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdatePushNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePushNotificationMutation, UpdatePushNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePushNotificationMutation, UpdatePushNotificationMutationVariables>(UpdatePushNotificationDocument, options);
      }
export type UpdatePushNotificationMutationHookResult = ReturnType<typeof useUpdatePushNotificationMutation>;
export type UpdatePushNotificationMutationResult = Apollo.MutationResult<UpdatePushNotificationMutation>;
export type UpdatePushNotificationMutationOptions = Apollo.BaseMutationOptions<UpdatePushNotificationMutation, UpdatePushNotificationMutationVariables>;
export const CreatePushNotificationDocument = gql`
    mutation createPushNotification($pushNotificationBody: PushNotificationInput!) {
  createPushNotification(body: $pushNotificationBody) {
    ...AppPushNotification
  }
}
    ${AppPushNotificationFragmentDoc}`;
export type CreatePushNotificationMutationFn = Apollo.MutationFunction<CreatePushNotificationMutation, CreatePushNotificationMutationVariables>;

/**
 * __useCreatePushNotificationMutation__
 *
 * To run a mutation, you first call `useCreatePushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPushNotificationMutation, { data, loading, error }] = useCreatePushNotificationMutation({
 *   variables: {
 *      pushNotificationBody: // value for 'pushNotificationBody'
 *   },
 * });
 */
export function useCreatePushNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePushNotificationMutation, CreatePushNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePushNotificationMutation, CreatePushNotificationMutationVariables>(CreatePushNotificationDocument, options);
      }
export type CreatePushNotificationMutationHookResult = ReturnType<typeof useCreatePushNotificationMutation>;
export type CreatePushNotificationMutationResult = Apollo.MutationResult<CreatePushNotificationMutation>;
export type CreatePushNotificationMutationOptions = Apollo.BaseMutationOptions<CreatePushNotificationMutation, CreatePushNotificationMutationVariables>;
export const HeartsDocument = gql`
    subscription Hearts {
  hearts {
    id
    collection
    count
  }
}
    `;

/**
 * __useHeartsSubscription__
 *
 * To run a query within a React component, call `useHeartsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHeartsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeartsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useHeartsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<HeartsSubscription, HeartsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HeartsSubscription, HeartsSubscriptionVariables>(HeartsDocument, options);
      }
export type HeartsSubscriptionHookResult = ReturnType<typeof useHeartsSubscription>;
export type HeartsSubscriptionResult = Apollo.SubscriptionResult<HeartsSubscription>;
export const SharedLinksDocument = gql`
    query sharedLinks($camp_id: Int!, $limit: Int, $offset: Int, $orderBy: String) {
  sharedLinks(
    camp_id: $camp_id
    limit: $limit
    offset: $offset
    orderBy: $orderBy
  ) {
    ...AppSharedLink
  }
}
    ${AppSharedLinkFragmentDoc}`;

/**
 * __useSharedLinksQuery__
 *
 * To run a query within a React component, call `useSharedLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedLinksQuery({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSharedLinksQuery(baseOptions: Apollo.QueryHookOptions<SharedLinksQuery, SharedLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedLinksQuery, SharedLinksQueryVariables>(SharedLinksDocument, options);
      }
export function useSharedLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedLinksQuery, SharedLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedLinksQuery, SharedLinksQueryVariables>(SharedLinksDocument, options);
        }
export function useSharedLinksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedLinksQuery, SharedLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedLinksQuery, SharedLinksQueryVariables>(SharedLinksDocument, options);
        }
export type SharedLinksQueryHookResult = ReturnType<typeof useSharedLinksQuery>;
export type SharedLinksLazyQueryHookResult = ReturnType<typeof useSharedLinksLazyQuery>;
export type SharedLinksSuspenseQueryHookResult = ReturnType<typeof useSharedLinksSuspenseQuery>;
export type SharedLinksQueryResult = Apollo.QueryResult<SharedLinksQuery, SharedLinksQueryVariables>;
export const CreateSharedLinkDocument = gql`
    mutation createSharedLink($camp_id: Int!, $body: SharedLinkInput!) {
  createSharedLink(camp_id: $camp_id, body: $body) {
    ...AppSharedLink
  }
}
    ${AppSharedLinkFragmentDoc}`;
export type CreateSharedLinkMutationFn = Apollo.MutationFunction<CreateSharedLinkMutation, CreateSharedLinkMutationVariables>;

/**
 * __useCreateSharedLinkMutation__
 *
 * To run a mutation, you first call `useCreateSharedLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSharedLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSharedLinkMutation, { data, loading, error }] = useCreateSharedLinkMutation({
 *   variables: {
 *      camp_id: // value for 'camp_id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateSharedLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateSharedLinkMutation, CreateSharedLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSharedLinkMutation, CreateSharedLinkMutationVariables>(CreateSharedLinkDocument, options);
      }
export type CreateSharedLinkMutationHookResult = ReturnType<typeof useCreateSharedLinkMutation>;
export type CreateSharedLinkMutationResult = Apollo.MutationResult<CreateSharedLinkMutation>;
export type CreateSharedLinkMutationOptions = Apollo.BaseMutationOptions<CreateSharedLinkMutation, CreateSharedLinkMutationVariables>;
export const UpdateSharedLinkDocument = gql`
    mutation updateSharedLink($id: Int!, $body: SharedLinkInput!) {
  updateSharedLink(id: $id, body: $body) {
    ...AppSharedLink
  }
}
    ${AppSharedLinkFragmentDoc}`;
export type UpdateSharedLinkMutationFn = Apollo.MutationFunction<UpdateSharedLinkMutation, UpdateSharedLinkMutationVariables>;

/**
 * __useUpdateSharedLinkMutation__
 *
 * To run a mutation, you first call `useUpdateSharedLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharedLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharedLinkMutation, { data, loading, error }] = useUpdateSharedLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateSharedLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSharedLinkMutation, UpdateSharedLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSharedLinkMutation, UpdateSharedLinkMutationVariables>(UpdateSharedLinkDocument, options);
      }
export type UpdateSharedLinkMutationHookResult = ReturnType<typeof useUpdateSharedLinkMutation>;
export type UpdateSharedLinkMutationResult = Apollo.MutationResult<UpdateSharedLinkMutation>;
export type UpdateSharedLinkMutationOptions = Apollo.BaseMutationOptions<UpdateSharedLinkMutation, UpdateSharedLinkMutationVariables>;
export const RegenerateSharedLinkDocument = gql`
    mutation regenerateSharedLink($id: Int!) {
  regenerateSharedLink(id: $id) {
    ...AppSharedLink
  }
}
    ${AppSharedLinkFragmentDoc}`;
export type RegenerateSharedLinkMutationFn = Apollo.MutationFunction<RegenerateSharedLinkMutation, RegenerateSharedLinkMutationVariables>;

/**
 * __useRegenerateSharedLinkMutation__
 *
 * To run a mutation, you first call `useRegenerateSharedLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateSharedLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateSharedLinkMutation, { data, loading, error }] = useRegenerateSharedLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegenerateSharedLinkMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateSharedLinkMutation, RegenerateSharedLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateSharedLinkMutation, RegenerateSharedLinkMutationVariables>(RegenerateSharedLinkDocument, options);
      }
export type RegenerateSharedLinkMutationHookResult = ReturnType<typeof useRegenerateSharedLinkMutation>;
export type RegenerateSharedLinkMutationResult = Apollo.MutationResult<RegenerateSharedLinkMutation>;
export type RegenerateSharedLinkMutationOptions = Apollo.BaseMutationOptions<RegenerateSharedLinkMutation, RegenerateSharedLinkMutationVariables>;
export const DeleteSharedLinkDocument = gql`
    mutation deleteSharedLink($id: Int!) {
  deleteSharedLink(id: $id)
}
    `;
export type DeleteSharedLinkMutationFn = Apollo.MutationFunction<DeleteSharedLinkMutation, DeleteSharedLinkMutationVariables>;

/**
 * __useDeleteSharedLinkMutation__
 *
 * To run a mutation, you first call `useDeleteSharedLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSharedLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSharedLinkMutation, { data, loading, error }] = useDeleteSharedLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSharedLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSharedLinkMutation, DeleteSharedLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSharedLinkMutation, DeleteSharedLinkMutationVariables>(DeleteSharedLinkDocument, options);
      }
export type DeleteSharedLinkMutationHookResult = ReturnType<typeof useDeleteSharedLinkMutation>;
export type DeleteSharedLinkMutationResult = Apollo.MutationResult<DeleteSharedLinkMutation>;
export type DeleteSharedLinkMutationOptions = Apollo.BaseMutationOptions<DeleteSharedLinkMutation, DeleteSharedLinkMutationVariables>;
export const SharedLinkDocument = gql`
    query sharedLink($link: String!, $password: String!) {
  sharedLink(link: $link, password: $password) {
    ...AppSharedLink
    ...SharedLinkPersons
  }
}
    ${AppSharedLinkFragmentDoc}
${SharedLinkPersonsFragmentDoc}`;

/**
 * __useSharedLinkQuery__
 *
 * To run a query within a React component, call `useSharedLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedLinkQuery({
 *   variables: {
 *      link: // value for 'link'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSharedLinkQuery(baseOptions: Apollo.QueryHookOptions<SharedLinkQuery, SharedLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedLinkQuery, SharedLinkQueryVariables>(SharedLinkDocument, options);
      }
export function useSharedLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedLinkQuery, SharedLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedLinkQuery, SharedLinkQueryVariables>(SharedLinkDocument, options);
        }
export function useSharedLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedLinkQuery, SharedLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedLinkQuery, SharedLinkQueryVariables>(SharedLinkDocument, options);
        }
export type SharedLinkQueryHookResult = ReturnType<typeof useSharedLinkQuery>;
export type SharedLinkLazyQueryHookResult = ReturnType<typeof useSharedLinkLazyQuery>;
export type SharedLinkSuspenseQueryHookResult = ReturnType<typeof useSharedLinkSuspenseQuery>;
export type SharedLinkQueryResult = Apollo.QueryResult<SharedLinkQuery, SharedLinkQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...AppUser
    ...AppUserAuthAreas
  }
}
    ${AppUserFragmentDoc}
${AppUserAuthAreasFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UsersDocument = gql`
    query Users {
  users {
    ...AppUser
    ...AppUserAuthAreas
  }
}
    ${AppUserFragmentDoc}
${AppUserAuthAreasFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const LoginDocument = gql`
    mutation Login($username: String!, $password: String!) {
  login(usernameOrEmail: $username, password: $password) {
    ...AppUser
    ...AppUserAuthAreas
  }
}
    ${AppUserFragmentDoc}
${AppUserAuthAreasFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($body: UserInput!) {
  createUser(body: $body) {
    ...AppUser
    ...AppUserAuthAreas
  }
}
    ${AppUserFragmentDoc}
${AppUserAuthAreasFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($userId: Int!, $body: UserUpdate!) {
  updateUser(userId: $userId, body: $body) {
    ...AppUser
    ...AppUserAuthAreas
  }
}
    ${AppUserFragmentDoc}
${AppUserAuthAreasFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($userId: Int!) {
  deleteUser(userId: $userId)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($userId: Int!, $newPassword: String!) {
  resetPassword(userId: $userId, newPassword: $newPassword)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdateUserAuthorizedAreasDocument = gql`
    mutation updateUserAuthorizedAreas($userId: Int!, $campId: Int!, $areas: String!, $isCampEditor: Boolean!) {
  updateUserAuthorizedAreas(
    userId: $userId
    campId: $campId
    areas: $areas
    isCampEditor: $isCampEditor
  ) {
    ...AppUser
    ...AppUserAuthAreas
  }
}
    ${AppUserFragmentDoc}
${AppUserAuthAreasFragmentDoc}`;
export type UpdateUserAuthorizedAreasMutationFn = Apollo.MutationFunction<UpdateUserAuthorizedAreasMutation, UpdateUserAuthorizedAreasMutationVariables>;

/**
 * __useUpdateUserAuthorizedAreasMutation__
 *
 * To run a mutation, you first call `useUpdateUserAuthorizedAreasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAuthorizedAreasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAuthorizedAreasMutation, { data, loading, error }] = useUpdateUserAuthorizedAreasMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      campId: // value for 'campId'
 *      areas: // value for 'areas'
 *      isCampEditor: // value for 'isCampEditor'
 *   },
 * });
 */
export function useUpdateUserAuthorizedAreasMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAuthorizedAreasMutation, UpdateUserAuthorizedAreasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAuthorizedAreasMutation, UpdateUserAuthorizedAreasMutationVariables>(UpdateUserAuthorizedAreasDocument, options);
      }
export type UpdateUserAuthorizedAreasMutationHookResult = ReturnType<typeof useUpdateUserAuthorizedAreasMutation>;
export type UpdateUserAuthorizedAreasMutationResult = Apollo.MutationResult<UpdateUserAuthorizedAreasMutation>;
export type UpdateUserAuthorizedAreasMutationOptions = Apollo.BaseMutationOptions<UpdateUserAuthorizedAreasMutation, UpdateUserAuthorizedAreasMutationVariables>;